<template>
<v-app id="inspire" style="background:#F9F9F9;">

<vue-header-admin></vue-header-admin>
  <v-main >
    <v-container style="margin-bottom: 72px;" fluid class="px-6 py-6">

       <v-tabs
       class="mt-3"
       color="#4CAF50"
                  left
                >
                  <v-tab>General</v-tab>
                  <v-tab>Finance</v-tab>
                  <v-tab>Modules</v-tab>
                  <v-tab>Vehicle Scrapers</v-tab>
                  <v-tab>Loan Settings</v-tab>
                  <v-tab>Voice Agent</v-tab>
                  <v-tab>Chat Agent Settings</v-tab>
                  <v-tab>Referral Sweepstakes</v-tab>
                  <!-- <v-tab>Letters</v-tab> -->
                  <!-- <v-tab>Grant Settings</v-tab> -->
                  <v-tab-item
                  style="background-color: transparent!important;"
                    :key="0"
                  >
        <v-row
            align="center"
            justify="center"
            class=" mb-5"
          >
            <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-6" id="basic">
                <v-card-text style="margin-bottom: -30px;" >
                  <v-row>

                    <v-col
                      cols="12"
                      md="12"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">Settings</h5>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                    <span style="color:#5D6167;">Sales Representative</span>


                      <v-select
                      label="Display to"
                        v-model="settings.sales_rep_flag"
                        :items="['None','All','Custom']"
                        inset
                      ></v-select>
                      <v-select
                      v-if="settings.sales_rep_flag == 'Custom'"
                        v-model="settings.sales_rep_accounts"
                        :items="companies"
                        chips
                        item-text="name"
                        item-value="user_id"
                        label="Select Users"
                        multiple
                      ></v-select>

                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                    <span style="color:#5D6167;">Referral Representative</span>

                      <v-select
                      label="Display to"
                        v-model="settings.ref_rep_flag"
                        :items="['None','All','Custom']"
                        inset
                      ></v-select>
                      <v-select
                      v-if="settings.ref_rep_flag == 'Custom'"
                        v-model="settings.ref_rep_accounts"
                        :items="companies"
                        chips
                        item-text="name"
                        item-value="user_id"
                        label="Select Users"
                        multiple
                      ></v-select>

                    </v-col>
                       <!-- <v-col
                      cols="12"
                      md="6"
                    >

                        <v-text-field
                            color="#e91e63"
                            label="Grant Max Count"
                            ref="name"
                        v-model="settings.grant_count"
                            class="font-size-input input-style"
                          >
                          </v-text-field>
                    </v-col> -->
                      <v-col
                      cols="12"
                      md="6"
                    >
                  <v-select
                            item-text="name"
                        item-value="id"
                        label="Payment Gateway"
                        class="font-size-input input-style"
                            placeholder="Select payment gateway"
                            v-model="settings.payment_gateway"
                            :items="payment_gateway_options"
                            ></v-select>

                    </v-col>
                      <v-col
                      cols="12"
                      md="6"
                    >
                    <p style="text-align:left;">Payment Mode</p>
                    <v-switch
                        v-model="settings.test_mode"
                        label="Test"
                        style="margin-bottom: 30px;"
                        color="green"
                        value="1"
                        inset
                      >
                      <template #prepend>
                        <v-label>Live</v-label>
                      </template>
                      </v-switch>

                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                    <p style="text-align:left;">1st Referral</p>
                    <v-select
                            item-text="name"
                        item-value="id"
                        label="Type"
                        class="font-size-input input-style"
                            placeholder="Select payment gateway"
                            v-model="settings.first_ref_type"
                            :items="['Value','Percent']"
                            ></v-select>


                  </v-col>
                  <v-col
                      cols="12"
                      md="3"
                    >
                    <p style="text-align:left;">&nbsp;</p>
                    <v-text-field
                                v-if="settings.first_ref_type == 'Value'"
                                v-model="settings.first_ref_value"
                                prefix="$"
                                :label="'Amount'"
                                v-bind="attrs"
                                v-on="on"
                                color="deep-purple"

                              >
                              </v-text-field>
                              <v-text-field
                                v-if="settings.first_ref_type == 'Percent'"
                                v-model="settings.first_ref_value"
                                prefix="%"
                                :label="'Percent'"
                                v-bind="attrs"
                                v-on="on"
                                color="deep-purple"

                              >
                              </v-text-field>
                      </v-col>

                      <v-col
                      cols="12"
                      md="3"
                    >
                    <p style="text-align:left;">2nd Referral</p>
                    <v-select
                            item-text="name"
                        item-value="id"
                        label="Type"
                        class="font-size-input input-style"
                            placeholder="Select payment gateway"
                            v-model="settings.second_ref_type"
                            :items="['Value','Percent']"
                            ></v-select>


                  </v-col>
                  <v-col
                      cols="12"
                      md="3"
                    >
                    <p style="text-align:left;">&nbsp;</p>
                    <v-text-field
                                v-if="settings.second_ref_type == 'Value'"
                                v-model="settings.second_ref_value"
                                prefix="$"
                                :label="'Amount'"
                                v-bind="attrs"
                                v-on="on"
                                color="deep-purple"

                              >
                              </v-text-field>
                              <v-text-field
                                v-if="settings.second_ref_type == 'Percent'"
                                v-model="settings.second_ref_value"
                                prefix="%"
                                :label="'Percent'"
                                v-bind="attrs"
                                v-on="on"
                                color="deep-purple"

                              >
                              </v-text-field>
                      </v-col>

                      <v-col
                      cols="12"
                      md="3"
                    >
                    <p style="text-align:left;">3rd Referral</p>
                    <v-select
                            item-text="name"
                        item-value="id"
                        label="Type"
                        class="font-size-input input-style"
                            placeholder="Select payment gateway"
                            v-model="settings.third_ref_type"
                            :items="['Value','Percent']"
                            ></v-select>


                  </v-col>
                  <v-col
                      cols="12"
                      md="3"
                    >
                    <p style="text-align:left;">&nbsp;</p>
                    <v-text-field
                                v-if="settings.third_ref_type == 'Value'"
                                v-model="settings.third_ref_value"
                                prefix="$"
                                :label="'Amount'"
                                v-bind="attrs"
                                v-on="on"
                                color="deep-purple"

                              >
                              </v-text-field>
                              <v-text-field
                                v-if="settings.third_ref_type == 'Percent'"
                                v-model="settings.third_ref_value"
                                prefix="%"
                                :label="'Percent'"
                                v-bind="attrs"
                                v-on="on"
                                color="deep-purple"

                              >
                              </v-text-field>
                      </v-col>


                      <v-col
                      cols="12"
                      md="3"
                    >
                    <p style="text-align:left;">4th Referral</p>
                    <v-select
                            item-text="name"
                        item-value="id"
                        label="Type"
                        class="font-size-input input-style"
                            placeholder="Select payment gateway"
                            v-model="settings.forth_ref_type"
                            :items="['Value','Percent']"
                            ></v-select>


                  </v-col>
                  <v-col
                      cols="12"
                      md="3"
                    >
                    <p style="text-align:left;">&nbsp;</p>
                    <v-text-field
                                v-if="settings.forth_ref_type == 'Value'"
                                v-model="settings.forth_ref_value"
                                prefix="$"
                                :label="'Amount'"
                                v-bind="attrs"
                                v-on="on"
                                color="deep-purple"

                              >
                              </v-text-field>
                              <v-text-field
                                v-if="settings.forth_ref_type == 'Percent'"
                                v-model="settings.forth_ref_value"
                                prefix="%"
                                :label="'Percent'"
                                v-bind="attrs"
                                v-on="on"
                                color="deep-purple"

                              >
                              </v-text-field>
                      </v-col>
                      <v-col
                      cols="12"
                      md="3"
                    >
                    <p style="text-align:left;">5th Referral</p>
                    <v-select
                            item-text="name"
                        item-value="id"
                        label="Type"
                        class="font-size-input input-style"
                            placeholder="Select payment gateway"
                            v-model="settings.fifth_ref_type"
                            :items="['Value','Percent']"
                            ></v-select>


                  </v-col>
                  <v-col
                      cols="12"
                      md="3"
                    >
                    <p style="text-align:left;">&nbsp;</p>
                    <v-text-field
                                v-if="settings.fifth_ref_type == 'Value'"
                                v-model="settings.fifth_ref_value"
                                prefix="$"
                                :label="'Amount'"
                                v-bind="attrs"
                                v-on="on"
                                color="deep-purple"

                              >
                              </v-text-field>
                              <v-text-field
                                v-if="settings.fifth_ref_type == 'Percent'"
                                v-model="settings.fifth_ref_value"
                                prefix="%"
                                :label="'Percent'"
                                v-bind="attrs"
                                v-on="on"
                                color="deep-purple"

                              >
                              </v-text-field>
                      </v-col>
                      <v-col
                      cols="12"
                      md="6"
                    ></v-col>

                      <v-col
                      cols="12"
                      md="6"
                    >
                    <v-text-field
                                v-model="settings.business_address"
                                :label="'Meeting Address'"
                                color="deep-purple"

                              />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                    <v-text-field
                                v-model="settings.video_meeting_link"
                                :label="'Video Meeting Link'"
                                color="deep-purple"

                              />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                     <v-select
                        v-model="settings.display_inventory_header"
                        :items="users_options"
                        chips
                        item-text="name"
                        item-value="user_id"
                        label="Display Inventory Header"
                        multiple
                      >
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-content>
                            <v-text-field v-model="searchTerm" placeholder="Search" @input="searchFruits"></v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                      </v-select>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                     <v-select
                        v-model="settings.display_purchase_program"
                        :items="['All','None','Custom']"
                        chips
                        label="Display Purchase Program"
                      >

                      </v-select>
                      <v-select
                      v-if="settings.display_purchase_program == 'Custom'"
                        v-model="settings.display_purchase_program_custom"
                        :items="users_options"
                        chips
                        item-text="name"
                        item-value="user_id"
                        label="Display Purchase Program Users"
                        multiple
                      >
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-content>
                            <v-text-field v-model="searchTerm" placeholder="Search" @input="searchFruits"></v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                      </v-select>
                    </v-col>
                     <v-col
                      cols="12"
                      md="6"
                    > <v-text-field
                                v-model="settings.purchase_program_link"
                                :label="'Purchase Program Link'"
                                color="deep-purple"

                              />
                    </v-col>
                     <v-col
                      cols="12"
                      md="6"
                    > <v-text-field
                    prefix="%"
                                v-model="settings.Interest_rate_1"
                                :label="'Credit Score( < 500) Interest Rate'"
                                color="deep-purple"

                              />
                    </v-col>
                     <v-col
                      cols="12"
                      md="6"
                    > <v-text-field
                    prefix="%"
                                v-model="settings.Interest_rate_2"
                                :label="'Credit Score( 501 - 600) Interest Rate'"
                                color="deep-purple"

                              />
                    </v-col>
                     <v-col
                      cols="12"
                      md="6"
                    > <v-text-field
                    prefix="%"
                                v-model="settings.Interest_rate_3"
                                :label="'Credit Score(601 - 660) Interest Rate'"
                                color="deep-purple"

                              />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    > <v-text-field
                    prefix="%"
                                v-model="settings.Interest_rate_4"
                                :label="'Credit Score(661 - 780) Interest Rate'"
                                color="deep-purple"

                              />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    > <v-text-field
                    prefix="%"
                                v-model="settings.Interest_rate_5"
                                :label="'Credit Score(781 - 850) Interest Rate'"
                                color="deep-purple"

                              />
                    </v-col>
                      <v-col
                      cols="12"
                      md="6"
                    > <v-text-field
                                v-model="settings.preapproved_url"
                                :label="'Pre Approved URL '"
                                color="deep-purple"

                              />
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">User Agreement</h5>
                    <html-editor v-model="settings.agreement"></html-editor>

                  </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-center mt-5">
                  <v-row>
                    <v-col>
                      <v-btn
                        color="#4CAF50"
                        large
                        @click="saveSettings"
                        class="
                        float-right
                          font-weight-bolder
                          btn-default
                          mb-5
                          px-8
                          ms-auto
                        "

                      >
                        Save
                      </v-btn>
                      </v-col>
                    </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <!-- <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-2" id="basic">
                <v-card-text  >
                  <v-row>

                    <v-col
                      cols="12"
                      md="12"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">Products({{totalCount}})</h5>
                    </v-col>
                    <v-col cols="12"
                      md="12" >
                      <v-btn
                        elevation="0"
                        @click="dialogAssign = true"
                        :ripple="false"
                        small
                        style="float: left;margin-right:15px;"
                        color="#4CAF50"
                        class="
                         ont-weight-bolder
                          btn-default
                          py-4
                          px-8
                          ms-auto
                          mt-sm-auto mt-4

                                      "
                        >Add Product </v-btn
                      >
                      <v-btn
                        @click="$router.push('/admin/preview-products')"
                        small
                        color="blue"
                        class="
                         ont-weight-bolder
                          btn-default
                          py-4
                          px-8
                          ms-auto
                          mt-sm-auto mt-4

                                      "
                        >Preview </v-btn
                      >

                      </v-col>
                    <v-col cols="12"
                      md="12">

                        <v-data-table
                            :headers="headers_jobs"
                            :options.sync="datatable_options"
                            :items="users"
                            class="table"
                            loading-text="Loading... Please wait"
                            :page.sync="page"
                            v-sortable-data-table
                            @sorted="saveOrder"
                            :items-per-page="itemsPerPage"
                            :footer-props="{
                                    firstIcon: '',
                                    lastIcon: '',
                                    prevIcon: '',
                                    nextIcon: '',
                                    'page-text': false,
                                    'items-per-page-options': [-1]
                                  }"

                        >

                        <template v-slot:item.status="{ item }">
                            {{item.status == 1 ? 'Active' :'Inactive'}}
                        </template>
                        <template v-slot:item.email="{ item }">
                            {{item.email ? item.email : 'Not Available'}}
                        </template>
                         <template v-slot:item.phone="{ item }">
                            {{item.phone_m ? item.phone_m : "Not Avilable"}}
                        </template>
                        <template v-slot:item.date_of_birth="{ item }">
                            {{dateFormat(item.dob)}}
                        </template>
                        <template v-slot:item.price="{ item }">
                            {{'$'+item.price}}
                        </template>
                         <template v-slot:item.edit="{ item }">
                             <v-btn
                            class="mx-2"
                            text
                            dark
                           @click="productEditOpen(item)"
                            x-small
                            color="blue"
                          >
                            <v-icon class="material-icons-round opacity-10"  size="20" dark>
                              edit
                            </v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.password="{ item }">
                             <v-btn
                            class="mx-2"
                            fab
                            dark
                            @click="dialogDetail = true,selectedItem = item"
                            x-small
                            color="green"
                          >
                            {{item.total_count}}
                          </v-btn>
                        </template>

                        <template v-slot:item.address="{ item }">
                        <span ><span v-if="item.address_1">{{ item.address_1 }}</span>
                        </span>
                        </template>
                        <template v-slot:item.status_id="{ item }">
                           <v-btn
                            class="mx-2"
                            dark
                            @click="changeStatus(item.user_id,item.status)"
                            x-small
                            :color="item.status==1 ? 'red':'green'"
                          >
                          {{item.status==1 ? 'Deactivate':'Activate'}}
                          </v-btn>
                        </template>
                        <template v-slot:item.document="{ item }">
                          {{item.is_uploaded_doc == 1 ? 'Available' : 'Not available'}}
                        </template>

                        <template v-slot:item.id="{ item }">

                          <v-btn
                            class="mx-2"
                            text
                            dark
                            @click="deleteItem(item.id)"
                            x-small
                            color="red"
                          >
                            <v-icon size="20" class="material-icons-round opacity-10" dark>
                              delete
                            </v-icon>
                          </v-btn>
                        </template>
                        </v-data-table>

                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
             <v-col cols="12" md="12">
             <v-card class="card-shadow border-radius-xl mt-2" id="basic">
                <v-card-text style="margin-bottom: -30px;" >
                  <v-row>

                    <v-col
                      cols="12"
                      md="12"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">Coupons({{totalCountCoupons}})</h5>
                    </v-col>
                    <v-col cols="12"
                      md="12" >
                         <v-btn
                                    color="#4CAF50"
                        class="
                         ont-weight-bolder
                          btn-default
                          py-4
                          px-8
                          ms-auto
                          mt-sm-auto mt-4

                                      "
                                        small
                                        style="float: left;margin-right:15px;"
                                        @click="dialogCoupon = true"
                                    >
                                        Add Coupon
                                    </v-btn>

                      </v-col>
                    <v-col cols="12"
                      md="12">

                        <v-data-table
                            :headers="headers_coupons"
                            :options.sync="datatable_options_coupons"
                            :items="coupons"
                            loading-text="Loading... Please wait"
                            :page.sync="page_coupons"
                            :items-per-page="itemsPerPage_coupons"
                            :footer-props="{
                                    firstIcon: '',
                                    lastIcon: '',
                                    prevIcon: '',
                                    nextIcon: '',
                                    'page-text': false,
                                    'items-per-page-options': [10, 50, 100,-1]
                                  }"

                            class="table"
                        >

                        <template v-slot:item.status="{ item }">
                            {{item.status == 1 ? 'Active' :'Inactive'}}
                        </template>
                        <template v-slot:item.email="{ item }">
                            {{item.email ? item.email : 'Not Available'}}
                        </template>
                         <template v-slot:item.phone="{ item }">
                            {{item.phone_m ? item.phone_m : "Not Avilable"}}
                        </template>
                        <template v-slot:item.date_of_birth="{ item }">
                            {{dateFormat(item.dob)}}
                        </template>
                        <template v-slot:item.price="{ item }">
                            {{'$'+item.price}}
                        </template>
                         <template v-slot:item.edit="{ item }">
                             <v-btn
                            class="mx-2"
                            text
                            dark
                           @click="promo = item,dialogCoupon=true"
                            x-small
                            color="blue"
                          >
                            <v-icon size="20" class="material-icons-round opacity-10" dark>
                              edit
                            </v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.password="{ item }">
                             <v-btn
                            class="mx-2"
                            fab
                            dark
                            @click="dialogDetail = true,selectedItem = item"
                            x-small
                            color="green"
                          >
                            {{item.total_count}}
                          </v-btn>
                        </template>

                        <template v-slot:item.address="{ item }">
                        <span ><span v-if="item.address_1">{{ item.address_1 }}</span>
                        </span>
                        </template>
                        <template v-slot:item.status_id="{ item }">
                           <v-btn
                            class="mx-2"
                            dark
                            @click="changeStatus(item.user_id,item.status)"
                            x-small
                            :color="item.status==1 ? 'red':'green'"
                          >
                          {{item.status==1 ? 'Deactivate':'Activate'}}
                          </v-btn>
                        </template>
                        <template v-slot:item.document="{ item }">
                          {{item.is_uploaded_doc == 1 ? 'Available' : 'Not available'}}
                        </template>

                        <template v-slot:item.id="{ item }">

                          <v-btn
                            class="mx-2"
                            text
                            dark
                            @click="deleteItemCoupon(item.id)"
                            x-small
                            color="red"
                          >
                            <v-icon size="20" class="material-icons-round opacity-10" dark>
                              delete
                            </v-icon>
                          </v-btn>
                        </template>
                        </v-data-table>
                        <div class="text-center pt-2">
                            <v-pagination
                            prev-icon="fa fa-angle-left"
                            next-icon="fa fa-angle-right"
                            class="pagination"
                            circle
                            color="#4CAF50"
                                v-model="page"
                                :length="pageCountCoupons"
                                @input="getCoupons"
                            ></v-pagination>
                            </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col> -->
          </v-row>
      </v-tab-item>
      <v-tab-item
                  style="background-color: transparent!important;"
                    :key="1"
                  >

                  <v-row
            align="center"
            justify="center"
            class="mt-10 mb-5"
          >
          <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl " id="basic">
                <v-card-text style="" >
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">Vehicle Taxes</h5>
                    </v-col>
                    <v-col
                      cols="4"
                      md="4"
                    >

                   <v-text-field
                                v-model="settings.tax_sales"
                                prefix="%"
                                :label="'Sales Tax'"
                                color="deep-purple"

                              >
                              </v-text-field>

                    </v-col>
                     <v-col
                      cols="4"
                      md="4"
                    >

                   <v-text-field
                                v-model="settings.tax_country"
                                prefix="%"
                                :label="'Country Tax'"
                                color="deep-purple"

                              >
                              </v-text-field>

                    </v-col>
                     <v-col
                      cols="4"
                      md="4"
                    >

                   <v-text-field
                                v-model="settings.tax_city"
                                prefix="%"
                                :label="'City Tax'"
                                color="deep-purple"

                              >
                              </v-text-field>

                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">Vehicle Packs</h5>
                    </v-col>
                    <v-col
                      cols="6"
                      md="6"
                    >
                   <v-data-table
                    :headers="[{ text: 'Item', value: 'item' },{ text: 'Cost', value: 'cost' },{ text: 'Actions', value: 'actions', sortable: false }]"
                    :items="vehicle_packs_description"
                    class="elevation-1"
                  >
                    <template v-slot:top>
                      <v-toolbar
                        flat
                      >
                        <v-toolbar-title class="ml-3">Description</v-toolbar-title>
                        <v-divider
                          class="mx-4"
                          inset
                          vertical
                        ></v-divider>
                        <v-spacer></v-spacer>
                        <v-dialog
                          v-model="dialogAddNew"
                          max-width="500px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="blue"
                              dark
                              class="mb-2 mr-3"
                              v-bind="attrs"
                              v-on="on"
                            >
                              New Item
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-title>
                              <span class="text-h5">{{ editedIndex === -1 ? 'New Item' : 'Edit Item' }}</span>
                            </v-card-title>

                            <v-card-text>
                              <v-container>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                  >
                                    <v-text-field
                                      v-model="editedItem.item"
                                      label="Item"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                  >
                                    <v-text-field
                                      v-model="editedItem.cost"
                                      prefix="$"
                                      label="Cost"
                                    ></v-text-field>
                                  </v-col>


                                </v-row>
                              </v-container>
                            </v-card-text>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="close"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="save"
                              >
                                Save
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogDelete" max-width="500px">
                          <v-card>
                            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        small
                        class="mr-2"
                        color="blue"
                        @click="editItem(item)"
                      >
                        fa fa-edit
                      </v-icon>
                      <v-icon
                        small
                        color="red"
                        @click="deleteItem(item)"
                      >
                        fa fa-trash
                      </v-icon>
                    </template>

                  </v-data-table>

                    </v-col>
                    <v-col
                      cols="6"
                      md="6"
                    >
                   <v-data-table
                    :headers="[{ text: 'Item', value: 'item' },{ text: 'Actions', value: 'actions', sortable: false }]"
                    :items="vehicle_packs_category"
                    class="elevation-1"
                  >
                    <template v-slot:top>
                      <v-toolbar
                        flat
                      >
                        <v-toolbar-title class="ml-3">Category</v-toolbar-title>
                        <v-divider
                          class="mx-4"
                          inset
                          vertical
                        ></v-divider>
                        <v-spacer></v-spacer>

                        <v-dialog
                          v-model="dialogAddNewCategory"
                          max-width="500px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="blue"
                              dark
                              class="mb-2 mr-3"
                              v-bind="attrs"
                              v-on="on"
                            >
                              New Item
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-title>
                              <span class="text-h5">{{ editedIndexCategory === -1 ? 'New Item' : 'Edit Item' }}</span>
                            </v-card-title>

                            <v-card-text>
                              <v-container>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                  >
                                    <v-text-field
                                      v-model="editedItemCategory.item"
                                      label="Item"
                                    ></v-text-field>
                                  </v-col>


                                </v-row>
                              </v-container>
                            </v-card-text>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="closeCategoy"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="saveCategory"
                              >
                                Save
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogDeleteCategory" max-width="500px">
                          <v-card>
                            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="blue darken-1" text @click="closeDeleteCategory">Cancel</v-btn>
                              <v-btn color="blue darken-1" text @click="deleteItemConfirmCategory">OK</v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        small
                        class="mr-2"
                        color="blue"
                        @click="editItemCategory(item)"
                      >
                        fa fa-edit
                      </v-icon>
                      <v-icon
                        small
                        color="red"
                        @click="deleteItemCategory(item)"
                      >
                        fa fa-trash
                      </v-icon>
                    </template>

                  </v-data-table>

                    </v-col>

                    </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center ">
                  <v-row>
                    <v-col>
                      <v-btn
                        color="#4CAF50"
                        large
                        @click="saveSettings"
                        class="
                        float-right
                          font-weight-bolder
                          btn-default
                          mb-5
                          px-8
                          ms-auto
                        "

                      >
                        Save
                      </v-btn>
                      </v-col>

                    </v-row>
                </v-card-actions>
                <v-card-text>
                <v-row>
                <v-col
                      cols="12"
                      md="12"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">Default Packs</h5>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                    >
                    <Packs :settings="settings" :data="settings.default_packs" :flag="packsFlag" @notify="notify" />

                    </v-col>
                </v-row>
                </v-card-text>
                    </v-card>
                    </v-col>

          </v-row>

                  </v-tab-item>
         <v-tab-item
                  style="background-color: transparent!important;"
                    :key="2"
                  >
                  <v-row
            align="center"
            justify="center"
            class="mt-10 mb-5"
          >
            <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-2" id="basic">
                <v-card-text style="margin-bottom: -30px;" >
                  <v-row>

                    <v-col
                      cols="12"
                      md="12"
                    >
                    <!-- <h1 class="text-center mt-5 mb-5">Company Settings</h1> -->
                    <h5 class="text-h4 font-weight-bold text-typo">Modules ({{totalCountLetter}})</h5>
                    </v-col>
                    <v-col cols="12"
                      md="12" >
                         <v-btn
                                    color="#4CAF50"
                        class="
                         ont-weight-bolder
                          btn-default
                          py-4
                          px-8
                          ms-auto
                          mt-sm-auto mt-4

                                      "
                                        small
                                        style="float: left;"
                                        @click="dialogAddModule= true"
                                    >
                                        Create New Module
                                    </v-btn>
                      </v-col>
                    <v-col cols="12"
                      md="12">

                        <v-data-table
                            :headers="headers_letter"
                            :options.sync="datatable_options_letter"
                            :items="letters"
                            loading-text="Loading... Please wait"
                            :page.sync="page_letter"
                            :items-per-page="itemsPerPage_letter"
                            hide-default-footer
                            class="table"
                        >

                        <template v-slot:item.is_iframe="{ item }">
                            {{item.is_iframe == 1 ? 'Iframe' :'New Tab'}}
                        </template>
                        <template v-slot:item.email="{ item }">
                            {{item.email ? item.email : 'Not Available'}}
                        </template>
                         <template v-slot:item.phone="{ item }">
                            {{item.phone_m ? item.phone_m : "Not Avilable"}}
                        </template>
                        <template v-slot:item.date_of_birth="{ item }">
                            {{dateFormat(item.dob)}}
                        </template>
                        <template v-slot:item.price="{ item }">
                            {{'$'+item.price}}
                        </template>
                        <template v-slot:item.title="{ item }" >
                           <span style="cursor:pointer;color:blue;" @click="$router.push('edit-letter/'+item.id)"> {{item.title}} </span>
                        </template>
                        <template v-slot:item.status="{ item }">
                            {{item.status == 1 ? 'Active' :'Inactive'}}
                        </template>
                        <template v-slot:item.edit="{ item }">
                             <v-btn
                            class="mx-2"
                            text
                            dark
                           @click="dialogAddModule= true,module_data = item"
                            x-small
                            color="blue"
                          >
                            <v-icon size="20" class="material-icons-round opacity-10" dark>
                              edit
                            </v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.password="{ item }">
                             <v-btn
                            class="mx-2"
                            fab
                            dark
                            @click="dialogDetail = true,selectedItem = item"
                            x-small
                            color="green"
                          >
                            {{item.total_count}}
                          </v-btn>
                        </template>

                        <template v-slot:item.address="{ item }">
                        <span ><span v-if="item.address_1">{{ item.address_1 }}</span>
                        </span>
                        </template>
                        <template v-slot:item.status_id="{ item }">
                           <v-btn
                            class="mx-2"
                            dark
                            @click="changeStatus(item.user_id,item.status)"
                            x-small
                            :color="item.status==1 ? 'red':'green'"
                          >
                          {{item.status==1 ? 'Deactivate':'Activate'}}
                          </v-btn>
                        </template>
                        <template v-slot:item.document="{ item }">
                          {{item.is_uploaded_doc == 1 ? 'Available' : 'Not available'}}
                        </template>

                        <template v-slot:item.id="{ item }">

                          <v-btn
                            class="mx-2"
                            text
                            dark
                            @click="deleteModule(item.id)"
                            x-small
                            color="red"
                          >
                           <v-icon size="20" class="material-icons-round opacity-10" dark>
                              delete
                            </v-icon>
                          </v-btn>
                        </template>
                        </v-data-table>
                        <div class="text-center pt-2">
                            <v-pagination
                            circle
                            prev-icon="fa fa-angle-left"
                            next-icon="fa fa-angle-right"
                            class="pagination"
                            color="#4CAF50"
                                v-model="page_letter"
                                :length="pageCountLetter"
                                @input="getLetters"
                            ></v-pagination>
                            </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          </v-tab-item>

          <!-- Vehicle Scrapers Tab -->
          <v-tab-item
                  style="background-color: transparent!important;"
                    :key="3"
                  >
                  <v-row
                    align="center"
                    justify="center"
                    class="mt-10 mb-5"
                  >
                    <v-col cols="12" md="12">
                      <v-card class="card-shadow border-radius-xl mt-2" id="basic">
                        <v-card-text style="margin-bottom: -30px;">
                          <v-row>
                            <v-col cols="12" md="12">
                              <h5 class="text-h4 font-weight-bold text-typo">Vehicle Scrapers ({{scrapers.length}})</h5>
                              <p class="text-subtitle-1 text-grey">Drag and drop rows to reorder scrapers and set priority</p>
                            </v-col>

                            <v-col cols="12" md="12">
                              <v-data-table
                                :headers="headers_scrapers"
                                :items="scrapers"
                                class="table"
                                loading-text="Loading... Please wait"
                                :page.sync="page_scrapers"
                                :items-per-page="itemsPerPage_scrapers"
                                hide-default-footer
                              >
                                <template v-slot:item="{ item, index }">
                                  <tr
                                    :key="item.id"
                                    draggable="true"
                                    @dragstart="dragStart($event, index)"
                                    @dragover.prevent
                                    @dragenter.prevent
                                    @drop="drop($event, index)"
                                    class="scraper-row"
                                  >
                                    <td>
                                      <v-icon class="drag-handle">mdi-drag</v-icon>
                                      {{ item.name }}
                                    </td>
                                    <td>
                                      <v-switch
                                        v-model="item.status"
                                        :color="item.status ? 'green' : 'red'"
                                        @change="updateScraperStatus(item)"
                                        :label="item.status ? 'Active' : 'Inactive'"
                                      ></v-switch>
                                    </td>
                                    <td>
                                      {{ item.priority }}
                                    </td>
                                    <td>
                                      {{ item.description }}
                                    </td>
                                    <td>
                                      <v-btn
                                        small
                                        dark
                                        color="blue"
                                        @click="openUserAccessDialog(item)"
                                      >
                                        Manage Access
                                      </v-btn>
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>

                              <div class="text-center pt-2">
                                <v-pagination
                                  circle
                                  prev-icon="fa fa-angle-left"
                                  next-icon="fa fa-angle-right"
                                  class="pagination"
                                  color="#4CAF50"
                                  v-model="page_scrapers"
                                  :length="pageCountScrapers"
                                  @input="getScrapers"
                                ></v-pagination>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions class="justify-center mt-5">
                          <v-row>
                            <v-col>
                              <v-btn
                                color="#4CAF50"
                                large
                                @click="saveSettings"
                                class="
                                float-right
                                  font-weight-bolder
                                  btn-default
                                  mb-5
                                  px-8
                                  ms-auto
                                "
                              >
                                Save
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- User Access Dialog -->
                  <user-access-dialog
                    v-model="dialogUserAccess"
                    :scraper="selectedScraper"
                  ></user-access-dialog>
          </v-tab-item>

          <!-- Loan Settings Tab -->
          <v-tab-item
                  style="background-color: transparent!important;"
                    :key="4"
                  >
        <v-row
            align="center"
            justify="center"
            class=" mb-5"
          >
            <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-6" id="loan-settings">
                <v-card-text style="margin-bottom: -30px;" >
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">Loan Settings</h5>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                    <span style="color:#5D6167;">APR Rate (%)</span>
                      <v-text-field
                        v-model="settings.loan_apr_rate"
                        type="number"
                        step="0.01"
                        min="0"
                        max="99.99"
                        suffix="%"
                        inset
                        class="font-size-input input-style"
                      ></v-text-field>
                      <small style="color:#5D6167;">Annual Percentage Rate for loan calculations (default: 6.70%)</small>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                    <span style="color:#5D6167;">Loan Term (Months)</span>
                      <v-text-field
                        v-model="settings.loan_term_months"
                        type="number"
                        min="12"
                        max="360"
                        suffix="months"
                        inset
                        class="font-size-input input-style"
                      ></v-text-field>
                      <small style="color:#5D6167;">Loan term in months (default: 84 months / 7 years)</small>
                    </v-col>
                  </v-row>

                  <!-- How it works section -->
                  <v-row class="mt-4">
                    <v-col cols="12">
                      <div style="background-color: #f8f9fa; border: 1px solid #e9ecef; border-radius: 8px; padding: 16px;">
                        <div style="display: flex; align-items: center; margin-bottom: 8px;">
                          <v-icon color="#6c757d" style="margin-right: 8px;">mdi-information</v-icon>
                          <strong style="color: #495057;">How it works:</strong>
                        </div>
                        <ul style="margin: 0; padding-left: 20px; color: #6c757d;">
                          <li>These settings will be used to calculate estimated monthly payments for all vehicles</li>
                          <li>The calculation uses the standard loan payment formula: M = P × [r(1+r)^n] / [(1+r)^n - 1]</li>
                          <li>Vehicle price is used as the principal amount</li>
                          <li>Estimated payments will appear alongside vehicle prices in listings</li>
                        </ul>
                      </div>
                    </v-col>
                  </v-row>

                  <!-- Test Payment Calculator -->
                  <v-row class="mt-4">
                    <v-col cols="12">
                      <h6 class="text-h6 font-weight-bold" style="color:#5D6167; margin-bottom: 16px;">Test Payment Calculator</h6>
                      <v-row>
                        <v-col cols="12" md="4">
                          <span style="color:#5D6167;">Vehicle Price ($)</span>
                          <v-text-field
                            v-model="testVehiclePrice"
                            type="number"
                            min="0"
                            prefix="$"
                            placeholder="25000"
                            inset
                            class="font-size-input input-style"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="d-flex align-center">
                          <v-btn
                            color="blue"
                            dark
                            @click="calculateTestPayment"
                            :disabled="!testVehiclePrice || testVehiclePrice <= 0"
                            class="mt-4"
                          >
                            Calculate Payment
                          </v-btn>
                        </v-col>
                        <v-col cols="12" md="4" class="d-flex align-center">
                          <div v-if="testPaymentResult" class="mt-4">
                            <div style="background-color: #e8f5e8; border: 1px solid #4caf50; border-radius: 8px; padding: 12px; text-align: center;">
                              <strong style="color: #2e7d32; font-size: 1.2rem;">${{ testPaymentResult }}/month</strong>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row class="mt-4">
                    <v-col cols="12" class="text-center">
                      <v-btn
                        color="green"
                        large
                        dark
                        @click="saveSettings"
                        :loading="loading"
                        class="px-8"
                      >
                        Save Settings
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          </v-tab-item>

          <!-- Voice Agent Settings Tab -->
          <v-tab-item
                  style="background-color: transparent!important;"
                    :key="5"
                  >
        <v-row
            align="center"
            justify="center"
            class=" mb-5"
          >
            <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-6" id="voice-agent-settings">
                <v-card-text style="margin-bottom: -30px;" >

                  <!-- Header Section -->
                  <v-row class="">
                    <v-col cols="12">
                      <h5 class="text-h4 font-weight-bold text-typo mb-2">
                        <i class="material-icons-round mr-2" style="vertical-align: middle; color: #1976d2; font-size: 32px;">phone_in_talk</i>
                        Retell AI Voice Agent Settings
                      </h5>
                      <p class="text-subtitle-1 text-muted">Configure AI-powered voice agents for automated customer interactions</p>
                    </v-col>
                  </v-row>

                  <!-- API Key Section -->
                  <v-row class="mb-8">
                    <v-col cols="12">
                      <v-card outlined class="pa-4">
                        <v-row>
                          <v-col cols="12">
                            <div class="d-flex align-center mb-2">
                              <i class="material-icons-round mr-2" style="color: #1976d2;">vpn_key</i>
                              <span class="font-weight-bold">Retell AI API Key</span>
                            </div>
                            <v-text-field
                              v-model="settings.retell_api_key"
                              placeholder="Enter your Retell AI API key"
                              outlined
                              dense
                              :append-icon="showRetellKey ? 'fa-eye' : 'fa-eye-slash'"
                              :type="showRetellKey ? 'text' : 'password'"
                              @click:append="showRetellKey = !showRetellKey"
                              hide-details="auto"
                            ></v-text-field>
                            <small class="text-muted mt-1">Get your API key from <a href="https://retellai.com" target="_blank">Retell AI Dashboard</a></small>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- Referring Agent Voice Section -->
                  <v-row class="mb-6">
                    <v-col cols="12" md="6">
                      <v-card outlined class="h-100">
                        <v-card-title class="blue white--text">
                          <i class="material-icons-round mr-2">person_add</i>
                          Referring Agent Voice
                        </v-card-title>
                        <v-card-text class="pt-4">
                          <v-row>
                            <!-- System Prompt -->
                            <v-col cols="12">
                              <div class="mb-2">
                                <i class="material-icons-round mr-1" style="font-size: 18px; vertical-align: middle;">chat</i>
                                <span class="font-weight-bold">System Prompt</span>
                              </div>
                              <v-textarea
                                v-model="settings.referring_agent_prompt"
                                rows="6"
                                placeholder="Define how the voice agent should interact with referring agents..."
                                outlined
                                dense
                                hide-details="auto"
                              ></v-textarea>
                              <small class="text-muted">This prompt defines the agent's personality, role, and conversation style.</small>
                            </v-col>

                            <!-- Flow File Upload -->
                            <v-col cols="12">
                              <div class="mb-2">
                                <i class="material-icons-round mr-1" style="font-size: 18px; vertical-align: middle;">description</i>
                                <span class="font-weight-bold">Conversation Flow (Optional)</span>
                              </div>
                              <v-file-input
                                v-model="referringAgentFlowFile"
                                accept=".json"
                                placeholder="Upload JSON flow file"
                                prepend-icon=""
                                outlined
                                dense
                                hide-details="auto"
                              >
                                <template v-slot:prepend-inner>
                                  <i class="material-icons-round" style="font-size: 20px;">attach_file</i>
                                </template>
                              </v-file-input>
                              <small class="text-muted">Upload a custom Retell AI conversation flow</small>
                            </v-col>

                            <!-- Status Card (if agent exists) -->
                            <v-col cols="12" v-if="referringAgent && referringAgent.has_voice_agent">
                              <div class="mb-2">
                                <i class="material-icons-round mr-1" style="font-size: 18px; vertical-align: middle;">info</i>
                                <span class="font-weight-bold">Agent Status</span>
                              </div>
                              <v-card outlined class="pa-3" color="success lighten-5">
                                <div class="d-flex align-center mb-2">
                                  <i class="material-icons-round mr-2" style="color: #4caf50;">check_circle</i>
                                  <span class="font-weight-bold">Active</span>
                                </div>
                                <div class="text-caption">
                                  <strong>Phone:</strong> {{ referringAgent.phone_number || 'Generating...' }}<br>
                                  <strong>Agent ID:</strong> <code class="text-caption">{{ referringAgent.agent_id }}</code>
                                </div>
                              </v-card>
                            </v-col>

                            <!-- Action Buttons -->
                            <v-col cols="12">
                              <v-divider class="my-2"></v-divider>
                              <div class="d-flex align-center flex-wrap" style="gap: 12px;">
                                <v-btn
                                  :color="referringAgent && referringAgent.has_voice_agent ? 'blue' : 'green'"
                                  large
                                  @click="createReferringAgent"
                                  dark
                                  :loading="creatingReferringAgent"
                                  :disabled="!settings.retell_api_key || !settings.referring_agent_prompt"
                                  class="px-8"
                                >
                                  <i class="material-icons-round mr-2" style="font-size: 18px;">{{ referringAgent && referringAgent.has_voice_agent ? 'refresh' : 'add' }}</i>
                                  {{ referringAgent && referringAgent.has_voice_agent ? 'Update Agent' : 'Create Agent' }}
                                </v-btn>

                                <!-- Test Voice Agent Button -->
                                <v-btn
                                  v-if="referringAgent && referringAgent.has_voice_agent"
                                  color="purple"
                                  large
                                  dark
                                  @click="testReferringAgent"
                                  :loading="testingReferringAgent"
                                  class="px-6"
                                >
                                  <i class="material-icons-round mr-2" style="font-size: 18px;">{{ isReferringAgentCallActive ? 'call_end' : 'phone_in_talk' }}</i>
                                  {{ isReferringAgentCallActive ? 'End Test Call' : 'Test Agent' }}
                                </v-btn>

                                <v-chip
                                  v-if="referringAgent && referringAgent.has_voice_agent"
                                  color="green"
                                  small
                                  dark
                                >
                                  <i class="material-icons-round mr-1" style="font-size: 14px;">check</i>
                                  Configured
                                </v-chip>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <!-- Sales Agent Voice Section -->
                    <v-col cols="12" md="6">
                      <v-card outlined class="h-100">
                        <v-card-title class="orange white--text">
                          <i class="material-icons-round mr-2">support_agent</i>
                          Sales Agent Voice
                        </v-card-title>
                        <v-card-text class="pt-4">
                          <v-row>
                            <!-- System Prompt -->
                            <v-col cols="12">
                              <div class="mb-2">
                                <i class="material-icons-round mr-1" style="font-size: 18px; vertical-align: middle;">chat</i>
                                <span class="font-weight-bold">System Prompt</span>
                              </div>
                              <v-textarea
                                v-model="settings.sales_agent_prompt"
                                rows="6"
                                placeholder="Define how the voice agent should interact with customers..."
                                outlined
                                dense
                                hide-details="auto"
                              ></v-textarea>
                              <small class="text-muted">This prompt defines the agent's personality, role, and conversation style.</small>
                            </v-col>

                            <!-- Flow File Upload -->
                            <v-col cols="12">
                              <div class="mb-2">
                                <i class="material-icons-round mr-1" style="font-size: 18px; vertical-align: middle;">description</i>
                                <span class="font-weight-bold">Conversation Flow (Optional)</span>
                              </div>
                              <v-file-input
                                v-model="salesAgentFlowFile"
                                accept=".json"
                                placeholder="Upload JSON flow file"
                                prepend-icon=""
                                outlined
                                dense
                                hide-details="auto"
                              >
                                <template v-slot:prepend-inner>
                                  <i class="material-icons-round" style="font-size: 20px;">attach_file</i>
                                </template>
                              </v-file-input>
                              <small class="text-muted">Upload a custom Retell AI conversation flow</small>
                            </v-col>

                            <!-- Status Card (if agent exists) -->
                            <v-col cols="12" v-if="salesAgent && salesAgent.has_voice_agent">
                              <div class="mb-2">
                                <i class="material-icons-round mr-1" style="font-size: 18px; vertical-align: middle;">info</i>
                                <span class="font-weight-bold">Agent Status</span>
                              </div>
                              <v-card outlined class="pa-3" color="success lighten-5">
                                <div class="d-flex align-center mb-2">
                                  <i class="material-icons-round mr-2" style="color: #4caf50;">check_circle</i>
                                  <span class="font-weight-bold">Active</span>
                                </div>
                                <div class="text-caption">
                                  <strong>Phone:</strong> {{ salesAgent.phone_number || 'Generating...' }}<br>
                                  <strong>Agent ID:</strong> <code class="text-caption">{{ salesAgent.agent_id }}</code>
                                </div>
                              </v-card>
                            </v-col>

                            <!-- Action Buttons -->
                            <v-col cols="12">
                              <v-divider class="my-2"></v-divider>
                              <div class="d-flex align-center flex-wrap" style="gap: 12px;">
                                <v-btn
                                  :color="salesAgent && salesAgent.has_voice_agent ? 'blue' : 'green'"
                                  large
                                  dark
                                  @click="createSalesAgent"
                                  :loading="creatingSalesAgent"
                                  :disabled="!settings.retell_api_key || !settings.sales_agent_prompt"
                                  class="px-8"
                                >
                                  <i class="material-icons-round mr-2" style="font-size: 18px;">{{ salesAgent && salesAgent.has_voice_agent ? 'refresh' : 'add' }}</i>
                                  {{ salesAgent && salesAgent.has_voice_agent ? 'Update Agent' : 'Create Agent' }}
                                </v-btn>

                                <!-- Test Voice Agent Button -->
                                <v-btn
                                  v-if="salesAgent && salesAgent.has_voice_agent"
                                  color="purple"
                                  large
                                  dark
                                  @click="testSalesAgent"
                                  :loading="testingSalesAgent"
                                  class="px-6"
                                >
                                  <i class="material-icons-round mr-2" style="font-size: 18px;">{{ isSalesAgentCallActive ? 'call_end' : 'phone_in_talk' }}</i>
                                  {{ isSalesAgentCallActive ? 'End Test Call' : 'Test Agent' }}
                                </v-btn>

                                <v-chip
                                  v-if="salesAgent && salesAgent.has_voice_agent"
                                  color="green"
                                  small
                                  dark
                                >
                                  <i class="material-icons-round mr-1" style="font-size: 14px;">check</i>
                                  Configured
                                </v-chip>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row class="mt-4 mb-5">
                    <v-col cols="12" class="text-center">
                      <v-btn
                        color="green"
                        large
                        dark
                        @click="saveSettings"
                        :loading="loading"
                        class="px-8"
                      >
                        Save Settings
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          </v-tab-item>

          <!-- Chat Agent Settings Tab -->
          <v-tab-item
                  style="background-color: transparent!important;"
                    :key="6"
                  >
        <v-row
            align="center"
            justify="center"
            class=" mb-5"
          >
            <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-6" id="chat-agent-settings">
                <v-card-text style="margin-bottom: -30px;" >
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">Chat Agent Settings</h5>
                    <p class="text-subtitle-1 text-muted">Configure AI system prompts for conversational chat agents</p>
                    </v-col>

                    <!-- Dealer Conversational Registration Prompt -->
                    <v-col cols="12" class="mb-4">
                      <v-card outlined class="pa-6" style="border: 1px solid #e0e0e0; border-radius: 12px;">
                        <div class="d-flex justify-space-between align-center mb-4">
                          <div class="d-flex align-center">
                            <v-avatar color="blue lighten-4" size="48" class="mr-3">
                              <span class="material-icons-round" style="color: #1976d2;">store</span>
                            </v-avatar>
                            <div>
                              <h3 class="font-weight-bold mb-1" style="color:#344767;">Dealer Conversational Registration</h3>
                              <p class="mb-0 text-caption" style="color:#7B809A;">AI assistant for dealership onboarding</p>
                            </div>
                          </div>
                          <v-btn
                            small
                            outlined
                            color="primary"
                            @click="resetDealerChatPrompt"
                            class="text-none"
                          >
                            <span class="material-icons-round" style="font-size: 18px; margin-right: 4px;">refresh</span>
                            Reset to Default
                          </v-btn>
                        </div>

                        <v-divider class="mb-4"></v-divider>

                        <div class="mb-2">
                          <label class="font-weight-medium mb-2 d-block" style="color:#344767; font-size: 14px;">
                            <span class="material-icons-round" style="font-size: 16px; vertical-align: middle; margin-right: 4px;">psychology</span>
                            System Prompt
                            <v-chip x-small color="blue" class="ml-2">OpenAI GPT-4.1</v-chip>
                          </label>
                          <v-textarea
                            v-model="settings.dealer_chat_prompt"
                            rows="10"
                            placeholder="Enter the system prompt for dealer conversational registration..."
                            outlined
                            dense
                            class="font-size-input"
                            style="font-family: 'Courier New', monospace; font-size: 13px;"
                          ></v-textarea>
                        </div>

                        <v-alert
                          dense
                          text
                          color="blue"
                          class="mb-0"
                          style="font-size: 13px;"
                        >
                          <strong>What this controls:</strong> Personality and tone of the AI assistant during dealer registration.<br>
                          <strong>Data collected:</strong> Dealership name, contact person, email, phone, address, inventory count, dealer license.<br>
                          <strong>💡 Tip:</strong> Customize the assistant's name, communication style, and approach while maintaining professional standards.
                        </v-alert>
                      </v-card>
                    </v-col>

                    <!-- Agent Chat Signup Prompt -->
                    <v-col cols="12" class="mb-4">
                      <v-card outlined class="pa-6" style="border: 1px solid #e0e0e0; border-radius: 12px;">
                        <div class="d-flex justify-space-between align-center mb-4">
                          <div class="d-flex align-center">
                            <v-avatar color="purple lighten-4" size="48" class="mr-3">
                              <span class="material-icons-round" style="color: #7b1fa2;">person_add</span>
                            </v-avatar>
                            <div>
                              <h3 class="font-weight-bold mb-1" style="color:#344767;">Referring Agent Chat Signup</h3>
                              <p class="mb-0 text-caption" style="color:#7B809A;">AI assistant for agent registration</p>
                            </div>
                          </div>
                          <v-btn
                            small
                            outlined
                            color="primary"
                            @click="resetAgentChatPrompt"
                            class="text-none"
                          >
                            <span class="material-icons-round" style="font-size: 18px; margin-right: 4px;">refresh</span>
                            Reset to Default
                          </v-btn>
                        </div>

                        <v-divider class="mb-4"></v-divider>

                        <div class="mb-2">
                          <label class="font-weight-medium mb-2 d-block" style="color:#344767; font-size: 14px;">
                            <span class="material-icons-round" style="font-size: 16px; vertical-align: middle; margin-right: 4px;">psychology</span>
                            System Prompt
                            <v-chip x-small color="primary" class="ml-2">OpenAI GPT-4.1</v-chip>
                          </label>
                          <v-textarea
                            v-model="settings.agent_chat_prompt"
                            rows="12"
                            placeholder="Enter the system prompt for referring agent chat signup..."
                            outlined
                            dense
                            class="font-size-input"
                            style="font-family: 'Courier New', monospace; font-size: 13px;"
                          ></v-textarea>
                        </div>

                        <v-alert
                          dense
                          text
                          color="purple"
                          class="mb-0"
                          style="font-size: 13px;"
                        >
                          <strong>What this controls:</strong> AI assistant's personality and conversation style.<br>
                          <strong>Data collected:</strong> first_name, last_name, email, phone, card_color, photo_preference<br>
                          <strong>💡 Tip:</strong> You can change the assistant's name, tone, and style while keeping the data collection flow intact.
                        </v-alert>
                      </v-card>
                    </v-col>

                    <!-- Beamer Club Chat Prompt -->
                    <v-col cols="12" class="mb-4">
                      <v-card outlined class="pa-6" style="border: 1px solid #e0e0e0; border-radius: 12px;">
                        <div class="d-flex justify-space-between align-center mb-4">
                          <div class="d-flex align-center">
                            <v-avatar color="orange lighten-4" size="48" class="mr-3">
                              <span class="material-icons-round" style="color: #f57c00;">directions_car</span>
                            </v-avatar>
                            <div>
                              <h3 class="font-weight-bold mb-1" style="color:#344767;">Beamer Club Program</h3>
                              <p class="mb-0 text-caption" style="color:#7B809A;">AI assistant for BMW member qualification</p>
                            </div>
                          </div>
                          <v-btn
                            small
                            outlined
                            color="primary"
                            @click="resetBeamerClubChatPrompt"
                            class="text-none"
                          >
                            <span class="material-icons-round" style="font-size: 18px; margin-right: 4px;">refresh</span>
                            Reset to Default
                          </v-btn>
                        </div>

                        <v-divider class="mb-4"></v-divider>

                        <div class="mb-2">
                          <label class="font-weight-medium mb-2 d-block" style="color:#344767; font-size: 14px;">
                            <span class="material-icons-round" style="font-size: 16px; vertical-align: middle; margin-right: 4px;">psychology</span>
                            System Prompt
                            <v-chip x-small color="orange" class="ml-2">OpenAI GPT-4.1</v-chip>
                          </label>
                          <v-textarea
                            v-model="settings.beamer_club_chat_prompt"
                            rows="10"
                            placeholder="Enter the system prompt for Beamer Club chat agent..."
                            outlined
                            dense
                            class="font-size-input"
                            style="font-family: 'Courier New', monospace; font-size: 13px;"
                          ></v-textarea>
                        </div>

                        <v-alert
                          dense
                          text
                          color="orange"
                          class="mb-0"
                          style="font-size: 13px;"
                        >
                          <strong>What this controls:</strong> Personality of the Beamer Club assistant during member qualification.<br>
                          <strong>Data collected:</strong> First name, last name, email, phone, date of birth, SSN last 4 digits.<br>
                          <strong>Program focus:</strong> BMW 5/6/7 Series qualification and income fleet setup.<br>
                          <strong>💡 Tip:</strong> Adjust the enthusiasm, professionalism, and explanation style for the BMW program benefits.
                        </v-alert>
                      </v-card>
                    </v-col>

                    <!-- Save Button -->
                    <v-col cols="12" class="text-center">
                      <v-btn
                        color="success"
                        x-large
                        dark
                        @click="saveSettings"
                        class="px-12 text-none"
                        elevation="2"
                        style="border-radius: 8px;"
                      >
                        <span class="material-icons-round mr-2">save</span>
                        Save Chat Agent Settings
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          </v-tab-item>

          <!-- Referral Sweepstakes Tab -->
          <v-tab-item
                  style="background-color: transparent!important;"
                    :key="7"
                  >
        <v-row
            align="center"
            justify="center"
            class=" mb-5"
          >
            <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-6" id="referral-sweepstakes">
                <v-card-text style="margin-bottom: -30px;" >
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">Referral Admin Panel</h5>
                    <p class="text-subtitle-1 text-muted">Configure referral sweepstakes settings and track performance</p>
                    </v-col>

                    <!-- Referral Goal -->
                    <v-col
                      cols="12"
                      md="6"
                    >
                    <span style="color:#5D6167;">Referral goal</span>
                      <v-text-field
                        v-model.number="settings.referral_goal"
                        type="number"
                        placeholder="1000"
                        inset
                        class="font-size-input input-style"
                      ></v-text-field>
                    </v-col>

                    <!-- Amount per referral -->
                    <v-col
                      cols="12"
                      md="6"
                    >
                    <span style="color:#5D6167;">Amount per referral</span>
                      <v-text-field
                        v-model.number="settings.amount_per_referral"
                        type="number"
                        prefix="$"
                        placeholder="3.00"
                        inset
                        class="font-size-input input-style"
                      ></v-text-field>
                    </v-col>

                    <!-- Bonus amount -->
                    <v-col
                      cols="12"
                      md="6"
                    >
                    <span style="color:#5D6167;">Bonus amount</span>
                      <v-text-field
                        v-model.number="settings.referral_bonus_amount"
                        type="number"
                        prefix="$"
                        placeholder="500"
                        inset
                        class="font-size-input input-style"
                      ></v-text-field>
                    </v-col>

                    <!-- Countdown timer end date -->
                    <v-col
                      cols="12"
                      md="6"
                    >
                    <span style="color:#5D6167;">Countdown timer end date</span>
                      <v-text-field
                        v-model="settings.referral_countdown_end"
                        type="datetime-local"
                        inset
                        class="font-size-input input-style"
                      ></v-text-field>
                    </v-col>

                    <!-- Stats Cards -->
                    <v-col cols="12" class="mt-4">
                      <v-row>
                        <!-- Total referrals received -->
                        <v-col cols="12" md="3">
                          <v-card class="pa-4" style="background: linear-gradient(195deg, #42A5F5 0%, #1976D2 100%); border-radius: 12px;">
                            <div style="color: white;">
                              <div class="text-caption font-weight-medium mb-2">Total referrals received</div>
                              <div class="text-h4 font-weight-bold">{{ referralStats.total_referrals || 0 }}</div>
                            </div>
                          </v-card>
                        </v-col>

                        <!-- Referrals remaining -->
                        <v-col cols="12" md="3">
                          <v-card class="pa-4" style="background: linear-gradient(195deg, #1976D2 0%, #1565C0 100%); border-radius: 12px;">
                            <div style="color: white;">
                              <div class="text-caption font-weight-medium mb-2">Referrals remaining</div>
                              <div class="text-h4 font-weight-bold">{{ referralsRemaining }}</div>
                            </div>
                          </v-card>
                        </v-col>

                        <!-- Total payout -->
                        <v-col cols="12" md="3">
                          <v-card class="pa-4" style="background: linear-gradient(195deg, #66BB6A 0%, #43A047 100%); border-radius: 12px;">
                            <div style="color: white;">
                              <div class="text-caption font-weight-medium mb-2">Total payout</div>
                              <div class="text-h4 font-weight-bold">${{ totalPayout }}</div>
                            </div>
                          </v-card>
                        </v-col>

                        <!-- Remaining bonus -->
                        <v-col cols="12" md="3">
                          <v-card class="pa-4" style="background: linear-gradient(195deg, #FFA726 0%, #FB8C00 100%); border-radius: 12px;">
                            <div style="color: white;">
                              <div class="text-caption font-weight-medium mb-2">Remaining bonus</div>
                              <div class="text-h4 font-weight-bold">${{ settings.referral_bonus_amount || 0 }}</div>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>

                    <!-- Total given summary -->
                    <v-col cols="12" class="mt-2">
                      <div class="text-h6 font-weight-medium text-typo">
                        Total given: ${{ totalGiven }} for {{ settings.referral_goal || 0 }} referrals
                      </div>
                    </v-col>

                    <!-- Countdown Timer Display -->
                    <v-col cols="12" class="mt-4" v-if="settings.referral_countdown_end">
                      <v-card outlined class="pa-4" style="border-radius: 12px;">
                        <div class="text-center">
                          <div class="text-h6 font-weight-medium mb-2">Countdown Timer</div>
                          <div class="text-h4 font-weight-bold" style="color: #1976D2;">
                            {{ countdownDisplay }}
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <!-- Leaderboard -->
                    <v-col cols="12" class="mt-6">
                      <h5 class="text-h5 font-weight-bold text-typo mb-4">Leaderboard</h5>
                      <v-card outlined style="border-radius: 12px;">
                        <v-data-table
                          :headers="leaderboardHeaders"
                          :items="leaderboardData"
                          :loading="loadingLeaderboard"
                          loading-text="Loading leaderboard..."
                          hide-default-footer
                          class="elevation-0"
                        >
                          <template v-slot:item.rank="{ index }">
                            {{ index + 1 }}
                          </template>
                          <template v-slot:item.name="{ item }">
                            <a
                              @click.prevent="openReferredUsersModal(item)"
                              style="color: #1976D2; text-decoration: none; cursor: pointer;"
                            >
                              {{ item.name }}
                            </a>
                          </template>
                          <template v-slot:item.referred="{ item }">
                            <span class="font-weight-bold">{{ item.referred }}</span>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>

                  </v-row>

                  <v-row class="mt-4">
                    <v-col cols="12" class="text-center">
                      <v-btn
                        color="green"
                        large
                        dark
                        @click="saveSettings"
                        :loading="loading"
                        class="px-8"
                      >
                        Save Settings
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          </v-tab-item>

          <!-- Referred Users Modal -->
          <v-dialog v-model="referredUsersModal" max-width="800px">
            <v-card>
              <v-card-title class="text-h5 primary white--text">
                <i class="material-icons-round mr-2">people</i>
                Referred Users
                <v-spacer></v-spacer>
                <v-btn icon dark @click="referredUsersModal = false">
                  <i class="material-icons-round">close</i>
                </v-btn>
              </v-card-title>

              <v-card-text class="pt-4">
                <div v-if="selectedReferrer" class="mb-4">
                  <h6 class="text-h6 font-weight-bold">Referrer: {{ selectedReferrer.name }}</h6>
                  <p class="text-body-2 grey--text">{{ selectedReferrer.email }}</p>
                  <v-divider class="my-3"></v-divider>
                  <p class="text-subtitle-1 font-weight-bold">
                    Total Referred: {{ referredUsers.length }} users
                  </p>
                </div>

                <v-data-table
                  :headers="referredUsersHeaders"
                  :items="referredUsers"
                  :loading="loadingReferredUsers"
                  loading-text="Loading referred users..."
                  class="elevation-1"
                  :items-per-page="10"
                >
                  <template v-slot:item.name="{ item }">
                    <div class="d-flex align-center py-2">
                      <v-avatar color="primary" size="36" class="mr-3">
                        <span class="white--text text-subtitle-2">
                          {{ item.name.charAt(0).toUpperCase() }}
                        </span>
                      </v-avatar>
                      <div>
                        <div class="font-weight-medium">{{ item.name }}</div>
                        <div class="text-caption grey--text">{{ item.email }}</div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:item.phone="{ item }">
                    <span>{{ item.phone || 'N/A' }}</span>
                  </template>
                  <template v-slot:item.joined_date="{ item }">
                    <v-chip small color="green" text-color="white">
                      {{ item.joined_date }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="referredUsersModal = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-tab-item
                  style="background-color: transparent!important;"
                    :key="7"
                  >
                  <v-row
            align="center"
            justify="center"
            class="mt-10 mb-5"
          >
            <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-2" id="basic">
                <v-card-text style="margin-bottom: 0px;" >
                  <v-row>

                    <v-col
                      cols="12"
                      md="12"
                    >
                    <!-- <h1 class="text-center mt-5 mb-5">Company Settings</h1> -->
                    <h5 class="text-h4 font-weight-bold text-typo">Focus Areas({{totalCountFA}})</h5>
                    </v-col>
                    <v-col cols="12"
                      md="12" >
                         <v-btn
                                    color="#4CAF50"
                        class="
                         ont-weight-bolder
                          btn-default
                          py-4
                          px-8
                          ms-auto
                          mt-sm-auto mt-4

                                      "
                                        small
                                        style="float: left;"
                                        @click="dialogAddFA = true"
                                    >
                                        Add Focus Area
                                    </v-btn>
                      </v-col>
                    <v-col cols="12"
                      md="12">

                        <v-data-table
                            :headers="headers_fa"
                            :options.sync="datatable_options_fa"
                            :items="focus_area"
                            loading-text="Loading... Please wait"
                            :page.sync="page_fa"
                            :items-per-page="itemsPerPage_fa"
                            hide-default-footer
                            class="table"
                        >

                        <template v-slot:item.is_iframe="{ item }">
                            {{item.is_iframe == 1 ? 'Iframe' :'New Tab'}}
                        </template>
                        <template v-slot:item.email="{ item }">
                            {{item.email ? item.email : 'Not Available'}}
                        </template>
                         <template v-slot:item.phone="{ item }">
                            {{item.phone_m ? item.phone_m : "Not Avilable"}}
                        </template>
                        <template v-slot:item.date_of_birth="{ item }">
                            {{dateFormat(item.dob)}}
                        </template>
                        <template v-slot:item.price="{ item }">
                            {{'$'+item.price}}
                        </template>
                        <template v-slot:item.title="{ item }" >
                           <span style="cursor:pointer;color:blue;" @click="$router.push('edit-letter/'+item.id)"> {{item.title}} </span>
                        </template>
                        <template v-slot:item.status="{ item }">
                            {{item.status == 1 ? 'Active' :'Inactive'}}
                        </template>
                        <template v-slot:item.edit="{ item }">
                             <v-btn
                            class="mx-2"
                            text
                            dark
                           @click="dialogAddFA = true"
                            x-small
                            color="blue"
                          >
                            <v-icon size="20" class="material-icons-round opacity-10" dark>
                              edit
                            </v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.password="{ item }">
                             <v-btn
                            class="mx-2"
                            fab
                            dark
                            @click="dialogDetail = true,selectedItem = item"
                            x-small
                            color="green"
                          >
                            {{item.total_count}}
                          </v-btn>
                        </template>

                        <template v-slot:item.address="{ item }">
                        <span ><span v-if="item.address_1">{{ item.address_1 }}</span>
                        </span>
                        </template>
                        <template v-slot:item.status_id="{ item }">
                           <v-btn
                            class="mx-2"
                            dark
                            @click="changeStatus(item.user_id,item.status)"
                            x-small
                            :color="item.status==1 ? 'red':'green'"
                          >
                          {{item.status==1 ? 'Deactivate':'Activate'}}
                          </v-btn>
                        </template>
                        <template v-slot:item.document="{ item }">
                          {{item.is_uploaded_doc == 1 ? 'Available' : 'Not available'}}
                        </template>
                          <template v-slot:item.edit="{ item }">
                             <v-btn
                            class="mx-2"
                            text
                            dark
                           @click="dialogAddFA = true, fa = item"
                            x-small
                            color="blue"
                          >
                            <v-icon size="20" class="material-icons-round opacity-10" dark>
                              edit
                            </v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.id="{ item }">

                          <v-btn
                            class="mx-2"
                            text
                            dark
                            @click="deleteItemFA(item.id)"
                            x-small
                            color="red"
                          >
                           <v-icon size="20" class="material-icons-round opacity-10" dark>
                              delete
                            </v-icon>
                          </v-btn>
                        </template>
                        </v-data-table>
                        <div class="text-center pt-2">
                            <v-pagination
                            circle
                            prev-icon="fa fa-angle-left"
                            next-icon="fa fa-angle-right"
                            class="pagination"
                            color="#4CAF50"
                                v-model="page_fa"
                                :length="pageCountFA"
                                @input="getFA"
                            ></v-pagination>
                            </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
               <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-2" id="basic">
                <v-card-text style="margin-bottom: -30px;" >
                  <v-row>

                    <v-col
                      cols="12"
                      md="12"
                    >
                    <!-- <h1 class="text-center mt-5 mb-5">Company Settings</h1> -->
                    <h5 class="text-h4 font-weight-bold text-typo">Locations({{totalCountL}})</h5>
                    </v-col>
                    <v-col cols="12"
                      md="12" >
                         <v-btn
                                    color="#4CAF50"
                        class="
                         ont-weight-bolder
                          btn-default
                          py-4
                          px-8
                          ms-auto
                          mt-sm-auto mt-4

                                      "
                                        small
                                        style="float: left;"
                                        @click="dialogAddL = true"
                                    >
                                        Add Location
                                    </v-btn>
                      </v-col>
                    <v-col cols="12"
                      md="12">

                        <v-data-table
                            :headers="headers_l"
                            :options.sync="datatable_options_l"
                            :items="locations"
                            loading-text="Loading... Please wait"
                            :page.sync="page_l"
                            :items-per-page="itemsPerPage_l"
                            hide-default-footer
                            class="table"
                        >

                        <template v-slot:item.is_iframe="{ item }">
                            {{item.is_iframe == 1 ? 'Iframe' :'New Tab'}}
                        </template>
                        <template v-slot:item.email="{ item }">
                            {{item.email ? item.email : 'Not Available'}}
                        </template>
                         <template v-slot:item.phone="{ item }">
                            {{item.phone_m ? item.phone_m : "Not Avilable"}}
                        </template>
                        <template v-slot:item.date_of_birth="{ item }">
                            {{dateFormat(item.dob)}}
                        </template>
                        <template v-slot:item.price="{ item }">
                            {{'$'+item.price}}
                        </template>
                        <template v-slot:item.title="{ item }" >
                           <span style="cursor:pointer;color:blue;" @click="$router.push('edit-letter/'+item.id)"> {{item.title}} </span>
                        </template>
                        <template v-slot:item.status="{ item }">
                            {{item.status == 1 ? 'Active' :'Inactive'}}
                        </template>
                        <template v-slot:item.edit="{ item }">
                             <v-btn
                            class="mx-2"
                            text
                            dark
                           @click="openEdit(item)"
                            x-small
                            color="blue"
                          >
                            <v-icon size="20" class="material-icons-round opacity-10" dark>
                              edit
                            </v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.password="{ item }">
                             <v-btn
                            class="mx-2"
                            fab
                            dark
                            @click="dialogDetail = true,selectedItem = item"
                            x-small
                            color="green"
                          >
                            {{item.total_count}}
                          </v-btn>
                        </template>

                        <template v-slot:item.address="{ item }">
                        <span ><span v-if="item.address_1">{{ item.address_1 }}</span>
                        </span>
                        </template>
                        <template v-slot:item.status_id="{ item }">
                           <v-btn
                            class="mx-2"
                            dark
                            @click="changeStatus(item.user_id,item.status)"
                            x-small
                            :color="item.status==1 ? 'red':'green'"
                          >
                          {{item.status==1 ? 'Deactivate':'Activate'}}
                          </v-btn>
                        </template>
                        <template v-slot:item.document="{ item }">
                          {{item.is_uploaded_doc == 1 ? 'Available' : 'Not available'}}
                        </template>
                          <template v-slot:item.edit="{ item }">
                             <v-btn
                            class="mx-2"
                            text
                            dark
                           @click="dialogAddL = true,location = item"
                            x-small
                            color="blue"
                          >
                            <v-icon size="20" class="material-icons-round opacity-10" dark>
                              edit
                            </v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.id="{ item }">

                          <v-btn
                            class="mx-2"
                            text
                            dark
                            @click="deleteItemLocation(item.id)"
                            x-small
                            color="red"
                          >
                           <v-icon size="20" class="material-icons-round opacity-10" dark>
                              delete
                            </v-icon>
                          </v-btn>
                        </template>
                        </v-data-table>
                        <div class="text-center pt-2">
                            <v-pagination
                            circle
                            prev-icon="fa fa-angle-left"
                            next-icon="fa fa-angle-right"
                            class="pagination"
                            color="#4CAF50"
                                v-model="page_l"
                                :length="pageCountL"
                                @input="getL"
                            ></v-pagination>
                            </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          </v-tab-item>
       </v-tabs>

           <v-dialog
        persistent
      v-model="dialogAssign"
      width="500"
    >

      <v-card>
        <v-card-title class="text-h5 grey lighten-2" v-if="!product.id">
          Add new Product
        </v-card-title>
        <v-card-title class="text-h5 grey lighten-2" v-else>
          Edit Product
        </v-card-title>
        <v-card-text style="margin-top:30px;">
          <v-text-field
                label="Credit"
                v-model="product.credit"
                v-mask="'###########################'"
          ></v-text-field>
          <v-text-field
                v-model="product.price"
                label="Price"
                prefix="$"
                v-mask="'###########################'"
          ></v-text-field>
              <v-select
              label="Type"
            v-model="product.type"
            :items="['Company','Client']"
          ></v-select>
          <v-text-field
                v-model="product.name"
                label="Name"
          ></v-text-field>
          <v-col cols="12">
                     <v-data-table
                          :headers="headers_basic"
                          :items="product.items"
                          sort-by="calories"
                          class="table mb-10"
                        >
                          <template v-slot:top>
                            <v-toolbar
                              flat
                            >
                              <v-toolbar-title>Items</v-toolbar-title>
                              <v-divider
                                class="mx-4"
                                inset
                                vertical
                              ></v-divider>
                              <v-spacer></v-spacer>
                              <v-btn
                                    color="blue"
                                    dark
                                    @click="dialog_basic = true,selected_item = 'plan1'"
                                    class="mb-2"
                                  >
                                    New Item
                                  </v-btn>
                            </v-toolbar>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-icon
                              small
                              class="material-icons-round mr-2"
                              @click="editItemBasic('plan1',item)"
                            >
                              edit
                            </v-icon>
                            <v-icon
                              small
                              class="material-icons-round"
                              @click="deleteItemBasic('plan1',item)"
                            >
                              delete
                            </v-icon>
                          </template>
                        </v-data-table>
                   </v-col>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          v-if="!product.id"
            color="#4caf50"
            text
            :disabled="loadingAssign"
            @click="addPromo()"
          >
            Submit
          </v-btn><v-btn
          v-else
            color="primary"
            text
            :disabled="loadingAssign"
            @click="editPromo()"
          >
            Submit
          </v-btn>
           <v-btn
            color="primary"
            text
            :disabled="loadingAssign"
            @click="dialogAssign = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
                                v-model="dialog_basic"
                                max-width="500px"
                              >
                                <v-card>
                                  <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                  </v-card-title>

                                  <v-card-text>
                                    <v-container>
                                      <v-row>
                                        <v-col
                                          cols="12"
                                          sm="12"
                                          md="12"
                                        >
                                          <v-text-field
                                            v-model="editedItemBasic.item"
                                            label="Enter Item"
                                          ></v-text-field>
                                        </v-col>

                                      </v-row>
                                    </v-container>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="closeBasic"
                                    >
                                      Cancel
                                    </v-btn>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="saveBasic(selected_item)"
                                    >
                                      Save
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>

    <v-dialog
        persistent
      v-model="dialogAddFA"
      width="500"
    >

      <v-card>
        <v-card-title class="text-h5 grey lighten-2" v-if="!fa.id">
          Add new Focus Area
        </v-card-title>
        <v-card-title class="text-h5 grey lighten-2" v-else>
          Edit Focus Area
        </v-card-title>

        <v-card-text style="margin-top:30px;">
          <v-text-field
                label="Name"
                v-model="fa.name"
          ></v-text-field>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          v-if="!fa.id"
            color="#4caf50"
            text
            :disabled="loadingAssign"
            @click="addFocusArea()"
          >
            Submit
          </v-btn><v-btn
          v-else
            color="primary"
            text
            :disabled="loadingAssign"
            @click="editFocusArea()"
          >
            Submit
          </v-btn>
           <v-btn
            color="primary"
            text
            :disabled="loadingAssign"
            @click="dialogAddFA = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        persistent
      v-model="dialogAddModule"
      width="500"
    >

      <v-card>
        <v-card-title class="text-h5 grey lighten-2" v-if="!module_data.id">
          Add new Module
        </v-card-title>
        <v-card-title class="text-h5 grey lighten-2" v-else>
          Edit Module
        </v-card-title>

        <v-card-text style="margin-top:30px;">

          <v-text-field
                label="Name"
                v-model="module_data.name"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          v-if="!location.id"
            color="#4caf50"
            text
            :disabled="loadingAssign"
            @click="saveModule()"
          >
            Submit
          </v-btn><v-btn
          v-else
            color="primary"
            text
            :disabled="loadingAssign"
            @click="saveModule()"
          >
            Submit
          </v-btn>
           <v-btn
            color="primary"
            text
            :disabled="loadingAssign"
            @click="dialogAddModule = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        persistent
      v-model="dialogAddL"
      width="500"
    >

      <v-card>
        <v-card-title class="text-h5 grey lighten-2" v-if="!location.id">
          Add new Location
        </v-card-title>
        <v-card-title class="text-h5 grey lighten-2" v-else>
          Edit Location
        </v-card-title>

        <v-card-text style="margin-top:30px;">

          <vuetify-google-autocomplete
                                    id="map"
                                    v-model="location.name"
                                    label="Location"
                                    color="#e91e63"
                                     :rules="rules"
                                    class="font-size-input input-style"
                                    placeholder="Enter a location"
                                    v-on:placechanged="getAddressData"
                                    country="us"
                                ></vuetify-google-autocomplete>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          v-if="!location.id"
            color="#4caf50"
            text
            :disabled="loadingAssign"
            @click="addLocation()"
          >
            Submit
          </v-btn><v-btn
          v-else
            color="primary"
            text
            :disabled="loadingAssign"
            @click="editLocation()"
          >
            Submit
          </v-btn>
           <v-btn
            color="primary"
            text
            :disabled="loadingAssign"
            @click="dialogAddL = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        persistent
      v-model="dialogCustomLink"
      width="500"
    >

      <v-card>
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
        <v-card-title class="text-h5 grey lighten-2" v-if="editFlag">
          Edit custom menu link
        </v-card-title>
        <v-card-title class="text-h5 grey lighten-2" v-else>
          Create a custom menu link
        </v-card-title>

        <v-card-text style="margin-top:30px;">
          <span style="color:#5D6167;">Link title</span>
          <v-text-field
                v-model="link.title"
                required
                :rules="nameRules"
                solo
          ></v-text-field>
          <!-- <span style="color:#5D6167;">Link icon</span>
          <v-dialog
            v-model="showDialog"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="700px"
            max-height="850px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="icon"
                :prepend-inner-icon="selectedIcon"
                :label="selectedIcon"
                v-bind="attrs"
                v-on="on"
                color="deep-purple"
                readonly
                solo
              >
              </v-text-field>
            </template>
            <v-card>
              <v-app-bar
                color="white"
                scroll-target="#scrolling-techniques-7"
                elevation="0"
              >
                <v-text-field
                  v-model="searchIcon"
                  placeholder="Search icon"
                  prepend-icon="mdi-magnify"
                  type="text"
                  onautocomplete="off"
                  dense
                />
              </v-app-bar>
              <v-sheet
                id="scrolling-techniques-7"
                class="overflow-y-auto"
                max-height="600"
              >
                <v-col cols="12">
                  <v-btn
                    v-for="(item, i) in allIcons"
                    :key="i"
                    @click="saveIcon(item)"
                    color="white"
                    class="mr-2 mb-2 "
                    fab
                    small
                    depressed
                  >
                    <v-icon color="grey darken-3"> mdi-{{ item }} </v-icon>
                  </v-btn>
                </v-col>

              </v-sheet>
            </v-card>
          </v-dialog> -->
          <span style="color:#5D6167;">URL</span>
          <v-text-field
                v-model="link.url"
                required
                :rules="nameRules"
                solo
          ></v-text-field>
          <v-switch
          label="Show link on sidebar"
            v-model="link.sidebar"
            inset
          ></v-switch>
          <v-switch
          label="Show to all accounts"
            v-model="link.all_account"
            inset
          ></v-switch>
          <v-select
          v-if="link.all_account == 0"
            v-model="link.list_account"
            :items="companies"
            chips
            item-text="name"
            item-value="id"
            label="Chips"
            multiple
            solo
          ></v-select>
          <v-switch
          label="Show to Dashboard"
            v-model="link.dashboard"
            inset
          ></v-switch>
          <v-switch
          label="Show to Client Profile"
            v-model="link.client"
            inset
          ></v-switch>
          <v-radio-group
            v-model="link.is_iframe"
            row
          >
            <v-radio
              label="Open in iFrame"
              :value="1"
            ></v-radio>
            <v-radio
              label="Open in a New Tab"
              :value="0"
            ></v-radio>
          </v-radio-group>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            v-if="!editFlag"
            :disabled="loadingCustomLink"
            @click="addLink()"
          >
            Submit
          </v-btn>
          <v-btn
            color="primary"
            text
            v-if="editFlag"
            :disabled="loadingCustomLink"
            @click="editLink()"
          >
            Submit
          </v-btn>
           <v-btn
            color="primary"
            text
            :disabled="loadingCustomLink"
            @click="dialogCustomLink = false"
          >
            Close
          </v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteBasic" max-width="500px">
                                <v-card>
                                  <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeDeleteBasic">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="deleteItemConfirmBasic(selected_item)">OK</v-btn>
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
    <v-dialog
        persistent
      v-model="dialogCoupon"
      width="500"
    >

      <v-card>
        <v-card-title class="text-h5 grey lighten-2" v-if="!promo.id">
          Add new Coupon code
        </v-card-title>
        <v-card-title class="text-h5 grey lighten-2" v-else>
          Edit Coupon code
        </v-card-title>

        <v-card-text style="margin-top:30px;">
          <v-text-field
          label="Name"
                v-model="promo.name"
                :disabled="promo.id ? true : false"
          ></v-text-field>
                 <v-select
                            label="Type"
                            placeholder="Select type"
                            :disabled="loadingAssign"
                            v-model="promo.type"
                            :items="['Percentage','Fixed']"
                            ></v-select>
          <v-text-field
          label="Discount"
          v-if="promo.type == 'Fixed'"
                v-model="promo.value"
                prefix="$"
                v-mask="'###########################'"
          ></v-text-field>
              <v-text-field
              label="Discount"
          v-if="promo.type == 'Percentage'"
                v-model="promo.value"
                suffix="%"
                v-mask="'###'"
          ></v-text-field>
                 <v-select
                 label="Usage Limit"
                            placeholder="Select Limit"
                            v-model="promo.count"
                            :items="['Unlimited','1','2','5','10','15']"
                            ></v-select>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            v-if="!promo.id"
            :disabled="loadingAssign"
            @click="addCoupon()"
          >
            Submit
          </v-btn>
           <v-btn
            color="primary"
            text
            v-else
            :disabled="loadingAssign"
            @click="editCoupon()"
          >
            Submit
          </v-btn>
           <v-btn
            color="primary"
            text
            :disabled="loadingAssign"
            @click="dialogCoupon = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-container>
    <vue-footer-admin></vue-footer-admin>
    </v-main>
</v-app>

</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import HtmlEditor from "../HtmlEditor.vue";
import Sortable from 'sortablejs';
import Packs from '@/components/Widgets/Packs.vue';
import UserAccessDialog from './UserAccessDialog.vue';
export default {
components: {
      VueTelInput, HtmlEditor, Packs, UserAccessDialog
  },
  data () {

      return {
        fname : '',
        lname : '',
        email : '',
        id: '',
        name:'',
        editedItemBasic: {
          item: '',
        },
        payment_gateway_options: [],
        phone:'',
        password : '',
        users : [],
        searchTerm:'',
        nameRules: [
        v => !!v || 'Field is required'
      ],
        valid: true,
        page:1,
        promo: {
          name : '',
          type : 'Percentage',
          value : '',
          count : 1,
        },
        itemsPerPage:10,
        confpassword : '',
        users_options: [],
        packsFlag : 'default',
        editedIndex: -1,
        editedIndexCategory: -1,
        users_options_old: [],
        dialogCoupon : false,
        role : '',
        headers_letter : [
           { text: 'Name', value: 'name',
            sortable: true },
            { text: 'Description', value: 'description',
            sortable: true },

          { text: 'Created at', value: 'created_at',
            sortable: true,width: '200' },
          { text: 'Updated at', value: 'updated_at',
            sortable: true,width: '200' },
            { text: 'Edit', value: 'edit',
            sortable: true,width: '200' },
          { text: 'Delete', value: 'id',
            sortable: false,width: '50' },
        ],
        headers_fa : [
           { text: 'Name', value: 'name',
            sortable: true },
          { text: 'Created at', value: 'created_at',
            sortable: true,width: '200' },
          { text: 'Updated at', value: 'updated_at',
            sortable: true,width: '200' },
            { text: 'Edit', value: 'edit',
            sortable: true,width: '200' },
          { text: 'Delete', value: 'id',
            sortable: false,width: '50' },
        ],
         headers_l : [
           { text: 'Name', value: 'name',
            sortable: true },
          { text: 'Created at', value: 'created_at',
            sortable: true,width: '200' },
          { text: 'Updated at', value: 'updated_at',
            sortable: true,width: '200' },
            { text: 'Edit', value: 'edit',
            sortable: true,width: '200' },
          { text: 'Delete', value: 'id',
            sortable: false,width: '50' },
        ],
        datatable_options_letter: {},
        datatable_options_fa: {},
        datatable_options_l: {},
        dialogAddFA : false,
        dialogAddL : false,
        headers_coupons : [  { text: 'Name', value: 'name',
            sortable: true },
          { text: 'Type', value: 'type',
            sortable: true },
          { text: 'Value', value: 'value',
            sortable: true },
             { text: 'Usage Limit', value: 'count',
            sortable: true },
          { text: 'Created at', value: 'created_at',
            sortable: true,width: '200' },
          { text: 'Updated at', value: 'updated_at',
            sortable: true,width: '200' },
            { text: 'Edit', value: 'edit',
            sortable: true,width: '200' },
          { text: 'Delete', value: 'id',
            sortable: false,width: '50' },],
        datatable_options_coupons : {},
        coupons : [],
        page_coupons : 1,
        page_fa : 1,
        page_l : 1,
        itemsPerPage_coupons :10,
        page_letter : 1,
        itemsPerPage_letter: 10,
        dialogAssign: false,
        pageCount: 1,
        fa : {
          name : '',
          id : ''
        },
        location : {
          name : '',
          id : ''
        },
        pageCountLetter : 1,
        pageCountCoupons : 1,
        vehicle_packs_description : [],
        vehicle_packs_category : [],

        // Vehicle Scrapers Tab
        scrapers: [],
        page_scrapers: 1,
        itemsPerPage_scrapers: 10,
        pageCountScrapers: 1,
        dialogUserAccess: false,
        selectedScraper: null,
        userProfiles: [],
        headers_scrapers: [
          { text: 'Name', value: 'name', sortable: false },
          { text: 'Status', value: 'status', sortable: false },
          { text: 'Priority', value: 'priority', sortable: false },
          { text: 'Description', value: 'description', sortable: false },
          { text: 'User Access', value: 'user_access', sortable: false },
        ],
        headers_users_access: [
          { text: 'User ID', value: 'user_id', sortable: true },
          { text: 'Name', value: 'name', sortable: true },
          { text: 'Email', value: 'email', sortable: true },
          { text: 'Role', value: 'role', sortable: true },
          { text: 'Has Access', value: 'has_access', sortable: false },
        ],
        pageCountFA : 1,
        pageCountL : 1,
        pageLink:1,
        pageCountLink: 1,
        totalCount: 0,
        totalCountLink: 0,
        companyname : '',
        previewbg:'',
        dialogAddModule: false,
        module_data: {
          id: '',
          name: '',

        },
        dialogDeleteBasic :  false,
        focus_area : [],
        headers_basic: [
          { text: 'Item', value: 'item' },
          { text: 'Actions', value: 'actions', sortable: false },
        ],
        dialog_basic: false,
        locations : [],
        sector : '',
        no_of_employee : '',
        showPassword : false,
        loadingAssign: false,
        limit: 10,
        limit_letter: 10,
        totalCountLetter : 0,

        totalCountFA : 0,
        totalCountL : 0,
        letters : [],
        dialogCustomLink: false,
        loadingCustomLink: false,
        dialogAddNew: false,
        dialogDelete: false,
        editedItem: {

        },
        dialogAddNewCategory: false,
        dialogDeleteCategory: false,
        editedItemCategory: {

        },
        phoneFlag:0,
        emailFlag:0,
        link: {
          title:'',
          icon: 'mdi-web',
          url: '',
          is_iframe: 1,
          sidebar:1,
          all_account: 1,
          list_account:[],
          dashboard : 0,
          client: 0
        },
        product: {
          credit: 0,
          price: 0,
          type :'Company',
          items : [],
          name : ''
        },
        country :'',
        datatable_options:{},
        otp_email:'',
        otp_phone:'',
        links: [],
        otp_phone_input:"",
        otp_email_input:"",
        user_phone:'',
        editFlag: false,
        companies: [],
        user_email:'',
        headers_jobs: [
          { text: 'Price', value: 'price',
            sortable: true },
          { text: 'Credit', value: 'credit',
            sortable: true },
          { text: 'Type', value: 'type',
            sortable: true },
          { text: 'Created at', value: 'created_at',
            sortable: true,width: '200' },
          { text: 'Updated at', value: 'updated_at',
            sortable: true,width: '200' },
            { text: 'Edit', value: 'edit',
            sortable: false },
          { text: 'Delete', value: 'id',
            sortable: false,width: '50' },
        ],
        headers_links: [
          { text: 'Title', value: 'title',
            sortable: false },
          { text: 'URL', value: 'url',
            sortable: false },
          { text: 'Open Mode', value: 'is_iframe',
            sortable: false },
          { text: 'Created at', value: 'created_at',
            sortable: false,width: '200' },
          { text: 'Updated at', value: 'updated_at',
            sortable: false,width: '200' },
            { text: 'Edit', value: 'edit',
            sortable: false,width: '200' },
          { text: 'Delete', value: 'id',
            sortable: false,width: '50' },
        ],
        status:0,
        settings :{
            payment_gateway: '',
            test_mode : 1,
            grant_count: 10,
            list_account : [],
            backgroung_logo: '',
            display_to : 'All',
            pricing :{
                user_credit : "",
            },
            loan_apr_rate: 6.70,
            loan_term_months: 84,
            elevenlabs_api_key: '',
            dealer_agent_prompt: `You are Alex, the official AutoSyncX™️ representative.
You only speak to dealerships about how AutoSyncX™️ helps them grow sales, set commissions, and connect with referral agents.

Your tone is professional, friendly, and confident — like a trusted sales consultant who genuinely wants to help dealerships succeed.

Key Points to Cover:
• Commission Flexibility: "You set your own commission rates — we don't dictate pricing"
• Agent Network: "Access to thousands of referral agents nationwide who bring qualified buyers"
• Easy Integration: "Simple inventory sync, no complex setup required"
• Transparent Payouts: "Clear commission structure, no hidden fees"
• Proven Results: "Dealerships typically see 20-30% more qualified leads within 60 days"

Always ask qualifying questions:
→ "What's your current monthly sales volume?"
→ "How are you currently generating leads?"
→ "What commission structure works best for your dealership?"

End conversations with clear next steps:
→ "Would you like me to walk you through sign-up?"
→ "Do you want to schedule a quick demo?"

Language Handling:
Default to English.
If the dealer asks in Spanish, respond fluently in Spanish, keeping the same professional but approachable tone.

Example starter line Alex would use:
"Hi, I'm Alex from AutoSyncX™️. I help dealerships expand their reach by connecting them with referral agents who bring in more buyers. How can I support your dealership today?"`,
            agent_agent_prompt: `You are Alex, the official AutoSyncX™ representative for referring agents.

You help referring agents understand how to:
- Earn $385 per car sold through their referral links
- Build residual income by recruiting dealerships
- Use their digital referral cards effectively
- Share cars and connect buyers with dealers
- Track their commissions and earnings

Key points to emphasize:
- $385 commission per car sold
- Residual income opportunities
- Easy 3-step process: Sign up → Share cars → Earn commissions
- No setup fees, 5-minute setup, 24/7 support
- Professional tools and marketing materials provided

Be enthusiastic, helpful, and focus on the earning potential and simplicity of the referring agent program.

Keep responses conversational, under 100 words, and always encourage them to get started or ask more questions.`,
            beamer_club_agent_prompt: `You are Alex, the official AutoSyncX™ Beamer Club representative.

You help BMW enthusiasts and potential buyers understand the exclusive Beamer Club program through AutoSyncX™.

Your tone is enthusiastic, knowledgeable, and passionate about BMWs — like a fellow BMW enthusiast who wants to share an amazing opportunity.

Key Points to Cover:
• Exclusive BMW Inventory: "Access to premium BMW vehicles from trusted dealerships nationwide"
• Special Pricing: "Beamer Club members get exclusive pricing and priority access to new inventory"
• Referral Rewards: "Earn rewards when you refer other BMW enthusiasts to the club"
• Community Benefits: "Join a community of BMW lovers with exclusive events and networking"
• Easy Process: "Simple sign-up, instant access to inventory, and dedicated support"

Always emphasize the BMW lifestyle and community aspect:
→ "As a BMW enthusiast, you deserve access to the best vehicles and the best deals"
→ "The Beamer Club is more than just buying a car — it's joining a community"

Ask qualifying questions:
→ "What BMW model are you most interested in?"
→ "Are you looking to upgrade your current BMW or buying your first one?"
→ "Would you like to see our current exclusive BMW inventory?"

End conversations with clear next steps:
→ "Would you like me to show you our current BMW inventory?"
→ "Ready to join the Beamer Club and get exclusive access?"

Language Handling:
Default to English.
If asked in Spanish, respond fluently in Spanish, maintaining the same enthusiastic and knowledgeable tone.

Example starter line:
"Hi! I'm Alex from AutoSyncX™ Beamer Club. I help BMW enthusiasts find their perfect BMW and connect with our exclusive community. Are you looking for a specific BMW model today?"

Keep responses conversational, enthusiastic, and always focus on the premium BMW experience and community benefits.`,
            dealer_chat_prompt: '',
            agent_chat_prompt: '',
            beamer_club_chat_prompt: '',
            referral_goal: 1000,
            amount_per_referral: 3.00,
            referral_bonus_amount: 500,
            referral_countdown_end: ''

        },
        // Referral Sweepstakes data
        referralStats: {
          total_referrals: 0,
          top_referrers: []
        },
        loadingLeaderboard: false,
        leaderboardHeaders: [
          { text: '#', value: 'rank', sortable: false, width: '80' },
          { text: 'Name', value: 'name', sortable: false },
          { text: 'Referred', value: 'referred', sortable: false, align: 'center' }
        ],
        // Referred Users Modal
        referredUsersModal: false,
        selectedReferrer: null,
        referredUsers: [],
        loadingReferredUsers: false,
        referredUsersHeaders: [
          { text: 'Name / Email', value: 'name', sortable: false },
          { text: 'Phone', value: 'phone', sortable: false },
          { text: 'Joined Date', value: 'joined_date', sortable: false, align: 'center' }
        ],
        countdownInterval: null,
        testVehiclePrice: '',
        testPaymentResult: null,
        tab: null,
        showDialog: false,
        showRetellKey: false,
        referringAgent: null,
        creatingReferringAgent: false,
        salesAgent: null,
        creatingSalesAgent: false,
        referringAgentFlowFile: null,
        salesAgentFlowFile: null,
        // Retell Test Call Properties
        testingReferringAgent: false,
        testingSalesAgent: false,
        isReferringAgentCallActive: false,
        isSalesAgentCallActive: false,
        retellWebClient: null,
        currentTestAgentType: null,
      icon: '',
      searchIcon: '',
      selectedIcon: 'mdi-check-outline',
      allIcons: [
        "account",
        "account-alert",
        "account-box",
        "account-box-outline",
        "account-check",
        "account-circle",
        "account-key",
        "tooltip-account",
        "account-minus",
        "web",
        "account-multiple",
        "account-multiple-outline",
        "account-multiple-plus",
        "account-network",
        "account-outline",
        "account-plus",
        "account-remove",
        "account-search",
        "account-star",
        "account-switch",
        "airballoon",
        "airplane",
        "airplane-off",
        "alarm",
        "alarm-check",
        "alarm-multiple",
        "alarm-off",
        "alarm-plus",
        "album",
        "alert",
        "alert-box",
        "alert-circle",
        "alert-octagon",
        "alpha",
        "alphabetical",
        "amazon",
        "google-cloud",
        "ambulance",
        "android",
        "android-debug-bridge",
        "android-studio",
        "apple",
        "apple-finder",
        "apple-ios",
        "apple-safari",
        "apps",
        "archive",
        "arrange-bring-forward",
        "arrange-bring-to-front",
        "arrange-send-backward",
        "arrange-send-to-back",
        "arrow-all",
        "arrow-bottom-left",
        "arrow-bottom-right",
        "arrow-collapse",
        "arrow-down",
        "arrow-down-bold",
        "arrow-down-bold-circle",
        "arrow-down-bold-circle-outline",
        "arrow-down-bold-hexagon-outline",
        "arrow-expand",
        "arrow-left",
        "arrow-left-bold",
        "arrow-left-bold-circle",
        "arrow-left-bold-circle-outline",
        "arrow-left-bold-hexagon-outline",
        "arrow-right",
        "arrow-right-bold",
        "arrow-right-bold-circle",
        "arrow-right-bold-circle-outline",
        "arrow-right-bold-hexagon-outline",
        "arrow-top-left",
        "arrow-top-right",
        "arrow-up",
        "arrow-up-bold",
        "arrow-up-bold-circle",
        "arrow-up-bold-circle-outline",
        "arrow-up-bold-hexagon-outline",
        "at",
        "attachment",
        "auto-fix",
        "auto-upload",
        "baby",
        "backburger",
        "backup-restore",
        "bank",
        "barcode",
        "barley",
        "barrel",
        "basket",
        "basket-fill",
        "basket-unfill",
        "battery",
        "battery-10",
        "battery-20",
        "battery-30",
        "battery-40",
        "battery-50",
        "battery-60",
        "battery-70",
        "battery-80",
        "battery-90",
        "battery-alert",
        "battery-charging-100",
        "battery-charging-20",
        "battery-charging-30",
        "battery-charging-40",
        "battery-charging-60",
        "battery-charging-80",
        "battery-charging-90",
        "battery-minus",
        "battery-negative",
        "battery-outline",
        "battery-plus",
        "battery-positive",
        "battery-unknown",
        "beach",
        "beaker",
        "beaker-outline",
        "beer",
        "bell",
        "bell-off",
        "bell-outline",
        "bell-ring",
        "bell-ring-outline",
        "bell-sleep",
        "beta",
        "bike",
        "binoculars",
        "bio",
        "biohazard",
        "bitbucket",
        "black-mesa",
        "blinds",
        "block-helper",
        "blogger",
        "bluetooth",
        "bluetooth-audio",
        "bluetooth-connect",
        "bluetooth-settings",
        "bluetooth-transfer",
        "blur",
        "blur-linear",
        "blur-off",
        "blur-radial",
        "bone",
        "book",
        "book-multiple",
        "book-open",
        "book-variant",
        "bookmark",
        "bookmark-check",
        "bookmark-music",
        "bookmark-outline",
        "bookmark-plus",
        "bookmark-remove",
        "border-all",
        "border-bottom",
        "border-color",
        "border-horizontal",
        "border-inside",
        "border-left",
        "border-none",
        "border-outside",
        "border-right",
        "border-top",
        "border-vertical",
        "bowling",
        "box",
        "briefcase",
        "briefcase-check",
        "briefcase-download",
        "briefcase-upload",
        "brightness-1",
        "brightness-2",
        "brightness-3",
        "brightness-4",
        "brightness-5",
        "brightness-6",
        "brightness-7",
        "brightness-auto",
        "broom",
        "brush",
        "bug",
        "bulletin-board",
        "bullhorn",
        "bus",
        "cake",
        "cake-variant",
        "calculator",
        "calendar",
        "calendar-blank",
        "calendar-check",
        "calendar-clock",
        "calendar-multiple",
        "calendar-multiple-check",
        "calendar-plus",
        "calendar-remove",
        "calendar-text",
        "calendar-today",
        "camcorder",
        "camcorder-off",
        "camera",
        "camera-front",
        "camera-front-variant",
        "camera-iris",
        "camera-party-mode",
        "camera-rear",
        "camera-rear-variant",
        "camera-switch",
        "camera-timer",
        "candycane",
        "car",
        "car-wash",
        "carrot",
        "cart",
        "cart-outline",
        "cash",
        "cash-100",
        "cash-multiple",
        "cash-usd",
        "cast",
        "cast-connected",
        "castle",
        "cat",
        "cellphone",
        "cellphone-android",
        "cellphone-dock",
        "cellphone-iphone",
        "cellphone-link",
        "cellphone-link-off",
        "cellphone-settings",
        "chair-school",
        "chart-arc",
        "chart-areaspline",
        "chart-bar",
        "chart-histogram",
        "chart-line",
        "chart-pie",
        "check",
        "check-all",
        "checkbox-blank",
        "checkbox-blank-circle",
        "checkbox-blank-circle-outline",
        "checkbox-blank-outline",
        "checkbox-marked",
        "checkbox-marked-circle",
        "checkbox-marked-circle-outline",
        "checkbox-marked-outline",
        "checkbox-multiple-blank",
        "checkbox-multiple-blank-outline",
        "checkbox-multiple-marked",
        "checkbox-multiple-marked-outline",
        "checkerboard",
        "chevron-double-down",
        "chevron-double-left",
        "chevron-double-right",
        "chevron-double-up",
        "chevron-down",
        "chevron-left",
        "chevron-right",
        "chevron-up",
        "church",
        "city",
        "clipboard",
        "clipboard-account",
        "clipboard-alert",
        "clipboard-arrow-down",
        "clipboard-arrow-left",
        "clipboard-check",
        "clipboard-outline",
        "clipboard-text",
        "clippy",
        "clock",
        "clock-fast",
        "close",
        "close-box",
        "close-box-outline",
        "close-circle",
        "close-circle-outline",
        "close-network",
        "closed-caption",
        "cloud",
        "apple-icloud",
        "cloud-check",
        "cloud-circle",
        "cloud-download",
        "cloud-outline",
        "cloud-off-outline",
        "cloud-upload",
        "cloud-refresh",
        "cloud-lock",
        "cloud-lock-outline",
        "cloud-question",
        "cloud-tags",
        "cloud-print",
        "cloud-print-outline",
        "cloud-search",
        "cloud-search-outline",
        "code-array",
        "code-braces",
        "code-equal",
        "code-greater-than",
        "code-less-than",
        "code-less-than-or-equal",
        "code-not-equal",
        "code-not-equal-variant",
        "code-string",
        "code-tags",
        "codepen",
        "coffee",
        "coffee-to-go",
        "color-helper",
        "comment",
        "comment-account",
        "comment-account-outline",
        "comment-alert",
        "comment-alert-outline",
        "comment-check",
        "comment-check-outline",
        "comment-multiple-outline",
        "comment-outline",
        "comment-plus-outline",
        "comment-processing",
        "comment-processing-outline",
        "comment-remove-outline",
        "comment-text",
        "comment-text-outline",
        "compare",
        "compass",
        "compass-outline",
        "console",
        "content-copy",
        "content-cut",
        "content-duplicate",
        "content-paste",
        "content-save",
        "content-save-all",
        "contrast",
        "contrast-box",
        "contrast-circle",
        "cow",
        "credit-card",
        "credit-card-multiple",
        "crop",
        "crop-free",
        "crop-landscape",
        "crop-portrait",
        "crop-square",
        "crosshairs",
        "crosshairs-gps",
        "crown",
        "cube",
        "cube-outline",
        "cube-unfolded",
        "cup",
        "cup-water",
        "currency-btc",
        "currency-eur",
        "currency-gbp",
        "currency-inr",
        "currency-rub",
        "currency-try",
        "currency-usd",
        "cursor-default",
        "cursor-default-outline",
        "cursor-move",
        "cursor-pointer",
        "database",
        "database-minus",
        "database-outline",
        "database-plus",
        "debug-step-into",
        "debug-step-out",
        "debug-step-over",
        "decimal-decrease",
        "decimal-increase",
        "delete",
        "delete-variant",
        "deskphone",
        "desktop-mac",
        "desktop-tower",
        "details",
        "deviantart",
        "diamond",
        "dice-1",
        "dice-2",
        "dice-3",
        "dice-4",
        "dice-5",
        "dice-6",
        "directions",
        "disqus",
        "division",
        "division-box",
        "dns",
        "domain",
        "dots-horizontal",
        "dots-vertical",
        "download",
        "drag",
        "drag-horizontal",
        "drag-vertical",
        "drawing",
        "drawing-box",
        "drone",
        "dropbox",
        "drupal",
        "duck",
        "dumbbell",
        "earth",
        "earth-off",
        "eject",
        "elevation-decline",
        "elevation-rise",
        "elevator",
        "email",
        "email-open",
        "email-outline",
        "emoticon",
        "emoticon-cool",
        "emoticon-devil",
        "emoticon-happy",
        "emoticon-neutral",
        "emoticon-poop",
        "emoticon-sad",
        "emoticon-tongue",
        "engine",
        "engine-outline",
        "equal",
        "equal-box",
        "eraser",
        "escalator",
        "evernote",
        "exclamation",
        "exit-to-app",
        "export",
        "eye",
        "eye-off",
        "eyedropper",
        "eyedropper-variant",
        "facebook",
        "facebook-messenger",
        "factory",
        "fan",
        "fast-forward",
        "ferry",
        "file",
        "file-cloud",
        "file-delimited",
        "file-document",
        "file-excel-box",
        "file-find",
        "file-image",
        "file-multiple",
        "file-music",
        "file-outline",
        "file-pdf",
        "file-pdf-box",
        "file-powerpoint",
        "file-powerpoint-box",
        "file-presentation-box",
        "file-video",
        "file-word",
        "file-word-box",
        "film",
        "filmstrip",
        "filmstrip-off",
        "filter",
        "filter-outline",
        "filter-remove-outline",
        "filter-variant",
        "fire",
        "firefox",
        "fish",
        "flag",
        "flag-checkered",
        "flag-outline",
        "flag-triangle",
        "flag-variant",
        "flash",
        "flash-auto",
        "flash-off",
        "flashlight",
        "flashlight-off",
        "flip-to-back",
        "flip-to-front",
        "floppy",
        "flower",
        "folder",
        "folder-account",
        "folder-download",
        "folder-google-drive",
        "folder-image",
        "folder-lock",
        "folder-lock-open",
        "folder-move",
        "folder-multiple",
        "folder-multiple-image",
        "folder-multiple-outline",
        "folder-outline",
        "folder-plus",
        "folder-remove",
        "folder-upload",
        "food",
        "food-apple",
        "food-variant",
        "football",
        "football-helmet",
        "format-align-center",
        "format-align-justify",
        "format-align-left",
        "format-align-right",
        "format-bold",
        "format-clear",
        "format-color-fill",
        "format-float-center",
        "format-float-left",
        "format-float-none",
        "format-float-right",
        "format-header-1",
        "format-header-2",
        "format-header-3",
        "format-header-4",
        "format-header-5",
        "format-header-6",
        "format-header-decrease",
        "format-header-equal",
        "format-header-increase",
        "format-header-pound",
        "format-indent-decrease",
        "format-indent-increase",
        "format-italic",
        "format-line-spacing",
        "format-list-bulleted",

        "format-paint",
        "format-paragraph",

        "format-size",
        "format-strikethrough",
        "format-subscript",
        "format-superscript",
        "format-text",
        "format-textdirection-l-to-r",
        "format-textdirection-r-to-l",
        "format-underline",
        "format-wrap-inline",
        "format-wrap-square",
        "format-wrap-tight",
        "format-wrap-top-bottom",
        "forum",
        "forward",
        "fridge",
        "fullscreen",
        "fullscreen-exit",
        "function",
        "gamepad",
        "gamepad-variant",
        "gas-station",
        "gavel",
        "gender-female",
        "gender-male",
        "gender-male-female",
        "gender-transgender",
        "gift",
        "git",
        "github",
        "glass-flute",
        "glass-mug",
        "glass-stange",
        "glass-tulip",
        "glasses",
        "gmail",
        "google",
        "google-chrome",
        "google-circles",
        "google-circles-communities",
        "google-circles-extended",
        "google-circles-group",
        "google-controller",
        "google-controller-off",
        "google-drive",
        "google-earth",
        "google-glass",
        "google-maps",

        "google-play",
        "google-plus",
        "google-hangouts",
        "grid",
        "grid-off",
        "group",

        "guitar-pick",
        "guitar-pick-outline",
        "hand-pointing-right",
        "hanger",

        "harddisk",
        "headphones",
        "headphones-box",
        "headphones-settings"
      ],


      }
    },
    directives: {
    sortableDataTable: {
      bind (el, binding, vnode) {
        const options = {
          animation: 150,
          onUpdate: function (event) {
            vnode.child.$emit('sorted', event)
          }
        }
        Sortable.create(el.getElementsByTagName('tbody')[0], options)
      }
    }
  },
  computed: {
    // Referral Sweepstakes computed properties
    referralsRemaining() {
      const goal = this.settings.referral_goal || 0;
      const received = this.referralStats.total_referrals || 0;
      return Math.max(0, goal - received);
    },
    totalPayout() {
      const received = this.referralStats.total_referrals || 0;
      const amountPerReferral = this.settings.amount_per_referral || 0;
      return (received * amountPerReferral).toFixed(2);
    },
    totalGiven() {
      const goal = this.settings.referral_goal || 0;
      const amountPerReferral = this.settings.amount_per_referral || 0;
      return (goal * amountPerReferral).toFixed(2);
    },
    leaderboardData() {
      return this.referralStats.top_referrers || [];
    },
    countdownDisplay() {
      if (!this.settings.referral_countdown_end) return '0 days 0h 0 min';

      const now = new Date().getTime();
      const endDate = new Date(this.settings.referral_countdown_end).getTime();
      const distance = endDate - now;

      if (distance < 0) {
        return 'Expired';
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      return `${days} days ${hours}h ${minutes} min`;
    }
  },
    methods: {
      saveOrder (event) {
      const movedItem = this.users.splice(event.oldIndex, 1)[0];
      this.users.splice(event.newIndex, 0, movedItem);
       axios({
          method: "POST",

          url: "/api/save-product-order",
          data : this.users,
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')}
        })
        .then(response => {
            console.log('product order saved');

         })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },
    saveOrderLink (event) {
      const movedItem = this.links.splice(event.oldIndex, 1)[0];
      this.links.splice(event.newIndex, 0, movedItem);
       axios({
          method: "POST",

          url: "/api/save-link-order",
          data : this.links,
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')}
        })
        .then(response => {
            console.log('product order saved');

         })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },
    openAdd(){
      this.link = {
          title:'',
          icon: 'mdi-web',
          url: '',
          is_iframe: 1,
          sidebar:1,
          all_account: 1,
          list_account:[],
        };
      this.dialogCustomLink = true;
    },
    openEdit(item){

      this.editFlag = true;
      this.link = item;
      this.link.list_account = Array.isArray(this.link.list_account) ? this.link.list_account : JSON.parse(this.link.list_account)
      console.log(this.link);
      this.selectedIcon = item.icon;
      this.dialogCustomLink = true;
    },
    getSettings() {
    let flag = 1;
    let url =process.env.VUE_APP_WASBI_URL
    var config = {headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache'}};
      axios({
          method: "POST",

          url: "/api/get-company-settings",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')}
        })
        .then(response => {
            let data = response.data.data;
            if(data){
              this.id = data.id;
              this.settings = data.settings;
              this.vehicle_packs_category = this.settings.vehicle_packs_category ? this.settings.vehicle_packs_category : [];
              this.vehicle_packs_description = this.settings.vehicle_packs_description ? this.settings.vehicle_packs_description : [];
              this.previewbg = url+data.settings.backgroung_logo

            }


         })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },

    // Vehicle Scrapers Tab Methods
    getScrapers() {
      const offset = (this.page_scrapers - 1) * this.itemsPerPage_scrapers;

      axios({
        method: "GET",
        url: `/api/vehicle-scrapers?limit=${this.itemsPerPage_scrapers}&offset=${offset}`,
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Authorization': "Bearer " + localStorage.getItem('token')
        }
      })
      .then(response => {
        if (response.data && response.data.data) {
          this.scrapers = response.data.data;
          this.pageCountScrapers = response.data.total_page || 1;
        } else {
          Vue.$toast.error('Failed to load scrapers', {
            position: 'top-right'
          });
        }
      })
      .catch(err => {
        Vue.$toast.error('Error loading scrapers', {
          position: 'top-right'
        });
        console.error(err);
      });
    },

    updateScraperStatus(scraper) {
      axios({
        method: "POST",
        url: "/api/vehicle-scrapers/update-status",
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Authorization': "Bearer " + localStorage.getItem('token')
        },
        data: {
          id: scraper.id,
          status: scraper.status ? 1 : 0
        }
      })
      .then(response => {
        if (response.data && response.data.success) {
          Vue.$toast.success('Scraper status updated', {
            position: 'top-right'
          });
        } else {
          Vue.$toast.error('Failed to update scraper status', {
            position: 'top-right'
          });
          // Revert the change if the update failed
          scraper.status = !scraper.status;
        }
      })
      .catch(err => {
        Vue.$toast.error('Error updating scraper status', {
          position: 'top-right'
        });
        console.error(err);
        // Revert the change if the update failed
        scraper.status = !scraper.status;
      });
    },

    updateScraperPriority(scraper) {
      axios({
        method: "POST",
        url: "/api/vehicle-scrapers/update-priority",
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Authorization': "Bearer " + localStorage.getItem('token')
        },
        data: {
          id: scraper.id,
          priority: scraper.priority
        }
      })
      .then(response => {
        if (response.data && response.data.success) {
          Vue.$toast.success('Scraper priority updated', {
            position: 'top-right'
          });
        } else {
          Vue.$toast.error('Failed to update scraper priority', {
            position: 'top-right'
          });
        }
      })
      .catch(err => {
        Vue.$toast.error('Error updating scraper priority', {
          position: 'top-right'
        });
        console.error(err);
      });
    },

    dragStart(event, index) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.dropEffect = 'move';
      event.dataTransfer.setData('itemIndex', index);

      // Add a class to the dragged element
      event.target.classList.add('dragging');
    },

    drop(event, dropIndex) {
      const dragIndex = event.dataTransfer.getData('itemIndex');

      // Remove the dragging class
      document.querySelectorAll('.dragging').forEach(el => {
        el.classList.remove('dragging');
      });

      if (dragIndex === dropIndex) return;

      // Reorder the items
      const movedItem = this.scrapers.splice(dragIndex, 1)[0];
      this.scrapers.splice(dropIndex, 0, movedItem);

      // Update priorities based on new order
      this.scrapers.forEach((scraper, index) => {
        scraper.priority = index + 1;
      });

      // Save the new order
      this.saveScraperOrder();
    },

    saveScraperOrder() {
      axios({
        method: "POST",
        url: "/api/vehicle-scrapers/save-order",
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Authorization': "Bearer " + localStorage.getItem('token')
        },
        data: this.scrapers
      })
      .then(response => {
        if (response.data && response.data.success) {
          Vue.$toast.success('Scraper order saved', {
            position: 'top-right'
          });
        } else {
          Vue.$toast.error('Failed to save scraper order', {
            position: 'top-right'
          });
        }
      })
      .catch(err => {
        Vue.$toast.error('Error saving scraper order', {
          position: 'top-right'
        });
        console.error(err);
      });
    },

    openUserAccessDialog(scraper) {
      this.selectedScraper = scraper;
      this.dialogUserAccess = true;
    },


     productEditOpen(item){
      this.product = item
      this.product.items = this.product.items ? Array.isArray(this.product.items) ? this.product.items :JSON.parse(this.product.items) : []
      this.dialogAssign=true
     },
     previewImageBG: function(event) {
      var input = event.target;
      console.log(input);
      if (input.files) {
        this.settings.backgroung_logo = input.files[0];
        var reader = new FileReader();
        reader.onload = (e) => {
          this.previewbg = e.target.result;
        }
        this.image=input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    searchFruits(e) {
      if (!this.searchTerm) {
        this.users_options = this.users_options_old;
      }
      this.users_options = this.users_options_old.filter((fruit) => {
        return fruit.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
      });
    },
     getAllCompanies(){
            let headers = {
                Authorization: "Bearer " + localStorage.getItem('token')
            }
            axios
            .get("/api/get-all-client", {headers: headers})
            .then(response => {
                this.companies = this.users_options_old = this.users_options = response.data.data;
            })
        },
        initialize(){
          if(confirm('Are you sure, You went to reset?'))
            this.vehicle_packs_description = [];
        },
    deleteItem(id){

          var r = confirm("Are you sure, You went to delete?");
          if (r == true) {
            axios
              .get("/api/delete-promo/"+id,this.header)
              .then(response => {
                  let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Deleted successfully', {
                      position: 'top-right'
                      });
                    this.getProducts();
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
            .catch(err => {
              Vue.$toast.error(err, {
              position: 'top-right'
              });
            })
          }
        },
        notify(data){
          this.settings.default_packs = data
          this.saveSettings()

        },
        deleteItemLocation(id){

          var r = confirm("Are you sure, You went to delete?");
          if (r == true) {
            axios
              .get("/api/delete-location/"+id,this.header)
              .then(response => {
                  let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Deleted successfully', {
                      position: 'top-right'
                      });
                    this.getL();
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
            .catch(err => {
              Vue.$toast.error(err, {
              position: 'top-right'
              });
            })
          }
        },
        deleteItemConfirmBasic (plan) {
        this.product.items.splice(this.editedIndexBasic, 1)
        this.closeDeleteBasic()
      },
        deleteItemFA(id){

          var r = confirm("Are you sure, You went to delete?");
          if (r == true) {
            axios
              .get("/api/delete-focus-area/"+id,this.header)
              .then(response => {
                  let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Deleted successfully', {
                      position: 'top-right'
                      });
                    this.getFA();
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
            .catch(err => {
              Vue.$toast.error(err, {
              position: 'top-right'
              });
            })
          }
        },
        deleteItemLetter(id){

          var r = confirm("Are you sure, You went to delete?");
          if (r == true) {
            axios
              .post("/api/delete-letter/"+id,this.header)
              .then(response => {
                  let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Deleted successfully', {
                      position: 'top-right'
                      });
                    this.getLetters();
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
            .catch(err => {
              Vue.$toast.error(err, {
              position: 'top-right'
              });
            })
          }
        },
         deleteModule(id){

          var r = confirm("Are you sure, You went to delete?");
          if (r == true) {
            axios
              .post("/api/delete-module/",{id:id},this.header)
              .then(response => {
                  let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Deleted successfully', {
                      position: 'top-right'
                      });
                    this.getLetters();
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
            .catch(err => {
              Vue.$toast.error(err, {
              position: 'top-right'
              });
            })
          }
        },
        deleteItemLink(id){

          var r = confirm("Are you sure, You went to delete?");
          if (r == true) {
            axios
              .get("/api/delete-link/"+id,this.header)
              .then(response => {
                  let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Deleted successfully', {
                      position: 'top-right'
                      });
                    this.getLinks();
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
            .catch(err => {
              Vue.$toast.error(err, {
              position: 'top-right'
              });
            })
          }
        },
        deleteItemBasic (flag,item) {
        this.editedIndexBasic = this.product.items.indexOf(item)
        this.editedItemBasic = Object.assign({}, item)
        this.dialogDeleteBasic = true
      },
        closeBasic () {
        this.dialog_basic = false
        this.$nextTick(() => {
          this.editedItemBasic = Object.assign({}, {item : ''})
          this.editedIndexBasic = -1
        })
      },
        getAddressData: function (addressData, placeResultData, id) {
            this.location.name = addressData.name;
        },
        editItemBasic (flag,item) {
        this.editedIndexBasic = this.product.items.indexOf(item)
        this.editedItemBasic = Object.assign({}, item)
        this.dialog_basic = true
      },
        saveBasic (item) {
        if (this.editedIndexBasic > -1) {
          Object.assign(this.product.items[this.editedIndexBasic], this.editedItemBasic)
        } else {
          this.product.items.push(this.editedItemBasic)
        }
        this.closeBasic()
      },
        deleteItemCoupon(id){

          var r = confirm("Are you sure, You went to delete?");
          if (r == true) {
            axios
              .get("/api/delete-coupon/"+id,this.header)
              .then(response => {
                  let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Deleted successfully', {
                      position: 'top-right'
                      });
                    this.getCoupons();
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
            .catch(err => {
              Vue.$toast.error(err, {
              position: 'top-right'
              });
            })
          }
        },
    getPayments(){
            this.loading = true;

            axios({
          method: "GET",

          url: "/api/get-all-payment-gateway",
           header : { headers : {
              Authorization:"Bearer " + localStorage.getItem('token')
              },
            }
        })
            .then(response => {

                let data = response.data;

            if (response.data) {
            this.payment_gateway_options = response.data.data
                }else {
                    Vue.$toast.error(data.message, {
                    position: 'top-right'
                    });
                }

            })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
        },
    addPromo(){
        this.loadingAssign = true;
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },

          url: "/api/add-promo",
          data: this.product
        })

          .then(response => {
              let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Product added successfully', {
                      position: 'top-right'
                      });
                      this.dialogAssign = false;
                      this.loadingAssign = false;
                      this.getProducts();
                      this.product.price = '';
                      this.product.credit = '';
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error('An active promotion code with `code: '+this.promo.name+'` already exists.', {
              position: 'top-right'
              });
              this.loadingAssign = false;
              })


      },
      addFocusArea(){
        this.loadingAssign = true;
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },

          url: "/api/add-focus-area",
          data: this.fa
        })

          .then(response => {
              let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Focus Area added successfully', {
                      position: 'top-right'
                      });
                      this.dialogAddFA = false;
                      this.loadingAssign = false;
                      this.getFA();
                      this.fa.name = '';
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error('An active promotion code with `code: '+this.promo.name+'` already exists.', {
              position: 'top-right'
              });
              this.loadingAssign = false;
              })


      },
      addLocation(){
        this.loadingAssign = true;
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },

          url: "/api/add-location",
          data: this.location
        })

          .then(response => {
              let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Location added successfully', {
                      position: 'top-right'
                      });
                      this.dialogAddL = false;
                      this.loadingAssign = false;
                      this.getL();
                      this.location.name = '';
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error('An active promotion code with `code: '+this.promo.name+'` already exists.', {
              position: 'top-right'
              });
              this.loadingAssign = false;
              })


      },
      addCoupon(){
        this.loadingAssign = true;
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },

          url: "/api/add-coupon-codes",
          data: this.promo
        })

          .then(response => {
              let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Coupon added successfully', {
                      position: 'top-right'
                      });
                      this.dialogCoupon = false;
                      this.loadingAssign = false;
                      this.getCoupons();
                      this.promo = {
                            name : '',
                            type : 'Percentage',
                            value : '',
                            count : 1
                          };
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error('An active Coupon code with `code: '+this.promo.name+'` already exists.', {
              position: 'top-right'
              });
              this.loadingAssign = false;
              })


      },
      editCoupon(){
        this.loadingAssign = true;
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },

          url: "/api/edit-coupon/"+this.promo.id,
          data: this.promo
        })

          .then(response => {
              let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Coupon edited successfully', {
                      position: 'top-right'
                      });
                      this.dialogCoupon = false;
                      this.loadingAssign = false;
                      this.getCoupons();
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error('An active Coupon code with `code: '+this.promo.name+'` already exists.', {
              position: 'top-right'
              });
              this.loadingAssign = false;
              })


      },
      editPromo(){
        this.loadingAssign = true;
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },

          url: "/api/edit-promo/"+this.product.id,
          data: this.product
        })

          .then(response => {
              let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Product edited successfully', {
                      position: 'top-right'
                      });
                      this.dialogAssign = false;
                      this.loadingAssign = false;
                      this.getProducts();
                      this.product.price = '';
                      this.product.credit = '';
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error('An active promotion code with `code: '+this.promo.name+'` already exists.', {
              position: 'top-right'
              });
              this.loadingAssign = false;
              })


      },
      saveModule(){
        if(this.module_data.name == ''){
          Vue.$toast.error('Module name is required', {
          position: 'top-right'
          });
        }else{
        this.loadingAssign = true;
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },

          url: "/api/save-module",
          data: this.module_data
        })

          .then(response => {
              let data = response.data;

              if (data.flag) {
                  Vue.$toast.success('Module saved successfully', {
                      position: 'top-right'
                      });
                      this.dialogAddModule = false;
                      this.loadingAssign = false;
                      this.getLetters();
                      this.module_data.name = '';
                      this.module_data.id = '';
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error('Module already exists.', {
              position: 'top-right'
              });
              this.loadingAssign = false;
              })
        }


      },
      editFocusArea(){
        this.loadingAssign = true;
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },

          url: "/api/edit-focus-area/"+this.fa.id,
          data: this.fa
        })

          .then(response => {
              let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Focus Area edited successfully', {
                      position: 'top-right'
                      });
                      this.dialogAddFA = false;
                      this.loadingAssign = false;
                      this.getFA();
                      this.fa.name = '';
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error('An active promotion code with `code: '+this.promo.name+'` already exists.', {
              position: 'top-right'
              });
              this.loadingAssign = false;
              })


      },
      uploadLogoBG(){
      const data = new FormData();
      let url =process.env.VUE_APP_WASBI_URL
        data.append('file_logo', this.settings.backgroung_logo);
        axios({
          method: "POST",
          url: "/api/upload-logo-background-admin",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')},
          data: data
          })
          .then(response => {
          Vue.$toast.success("Logo uploaded", {
              position: 'top-right'
              });
              console.log();
              this.settings.backgroung_logo = response.data.data
              this.saveSettings()
              localStorage.setItem('admin_bg',url+response.data.data)
          this.loadingUpload = false;

          })
          .catch(err => {
              Vue.$toast.error("Invalid file to upload", {
              position: 'top-right'
              });
              this.isDisableUpload = false;
              this.isDarkUpload = true;
          });

    },
      editLocation(){
        this.loadingAssign = true;
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },

          url: "/api/edit-location/"+this.location.id,
          data: this.location
        })

          .then(response => {
              let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Location edited successfully', {
                      position: 'top-right'
                      });
                      this.dialogAddL = false;
                      this.loadingAssign = false;
                      this.getL();
                      this.location.name = '';
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error('An active promotion code with `code: '+this.promo.name+'` already exists.', {
              position: 'top-right'
              });
              this.loadingAssign = false;
              })


      },
      addLink(){
        if(this.$refs.form.validate()){
        this.loadingCustomLink = true;
        let req = this.link;
        req.icon = this.selectedIcon;
        req.list_account = JSON.stringify(req.list_account)
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },

          url: "/api/add-cusom-link",
          data: req
        })

          .then(response => {
              let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Custom Link added successfully', {
                      position: 'top-right'
                      });
                      this.dialogCustomLink = false;
                      this.loadingCustomLink = false;
                      this.getLinks();
                      this.link.title = '';
                      this.link.url= '';
                      this.link.list_account= [];
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error(err, {
              position: 'top-right'
              });
              this.loadingCustomLink = false;
              })
        }


      },
      editLink(){
        if(this.$refs.form.validate()){
        this.loadingCustomLink = true;
        let req = this.link;
        req.icon = this.selectedIcon;
        req.list_account = JSON.stringify(req.list_account)
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },

          url: "/api/edit-custom-link",
          data: req
        })

          .then(response => {
              let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Custom Link edited successfully', {
                      position: 'top-right'
                      });
                      this.dialogCustomLink = false;
                      this.loadingCustomLink = false;
                      this.getLinks();
                      this.link.title = '';
                      this.link.url= '';
                      this.link.list_account= [];
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error(err, {
              position: 'top-right'
              });
              this.loadingCustomLink = false;
              })
        }


      },
    getProducts(){
      this.loading = true;
            this.offset = (this.page - 1) * this.datatable_options.itemsPerPage
            this.selected_project = name;
            let req = {
              limit : this.datatable_options.itemsPerPage,
              offset : this.offset,
              sort : this.datatable_options.sortBy,
              sortDesc : this.datatable_options.sortDesc && this.datatable_options.sortDesc[0] == false ? 'ASC'  :'DESC',
              search : this.search
            }
            axios({
          method: "POST",

          url: "/api/get-promo-codes",
          data: req,
           header : { headers : {
              Authorization:"Bearer " + localStorage.getItem('token')
              },
            }
        })
            .then(response => {

                let data = response.data;

            if (response.data) {
              console.log(data);
                this.users = data.data;
                this.pageCount = data.total_page
                this.totalCount = data.count
                console.log( this.users);
                this.loading = false;
                }else {
                    Vue.$toast.error(data.message, {
                    position: 'top-right'
                    });
                }

            })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },
    getFA(){
      this.loading = true;
            this.offset = (this.page - 1) * this.datatable_options_fa.itemsPerPage
            this.selected_project = name;
            let req = {
              limit : this.datatable_options.itemsPerPage,
              offset : this.offset,
              sort : this.datatable_options.sortBy,
              sortDesc : this.datatable_options.sortDesc && this.datatable_options.sortDesc[0] == false ? 'ASC'  :'DESC',
              search : ''
            }
            axios({
          method: "POST",

          url: "/api/get-focus-area",
          data: req,
           header : { headers : {
              Authorization:"Bearer " + localStorage.getItem('token')
              },
            }
        })
            .then(response => {

                let data = response.data;

            if (response.data) {
              console.log(data);
                this.focus_area = data.data;
                this.pageCountFA = data.total_page
                this.totalCountFA = data.count
                this.loading = false;
                }else {
                    Vue.$toast.error(data.message, {
                    position: 'top-right'
                    });
                }

            })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },
    getL(){
      this.loading = true;
            this.offset = (this.page - 1) * this.datatable_options_l.itemsPerPage
            this.selected_project = name;
            let req = {
              limit : this.datatable_options.itemsPerPage,
              offset : this.offset,
              sort : this.datatable_options.sortBy,
              sortDesc : this.datatable_options.sortDesc && this.datatable_options.sortDesc[0] == false ? 'ASC'  :'DESC',
              search : ''
            }
            axios({
          method: "POST",

          url: "/api/get-location",
          data: req,
           header : { headers : {
              Authorization:"Bearer " + localStorage.getItem('token')
              },
            }
        })
            .then(response => {

                let data = response.data;

            if (response.data) {
              console.log(data);
                this.locations = data.data;
                this.pageCountL = data.total_page
                this.totalCountL = data.count
                this.loading = false;
                }else {
                    Vue.$toast.error(data.message, {
                    position: 'top-right'
                    });
                }

            })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },
    getCoupons(){
      this.loading = true;
            this.offset = (this.page - 1) * this.datatable_options_coupons.itemsPerPage
            this.selected_project = name;
            let req = {
              limit : this.datatable_options_coupons.itemsPerPage,
              offset : this.offset,
              sort : this.datatable_options_coupons.sortBy,
              sortDesc : this.datatable_options_coupons.sortDesc && this.datatable_options_coupons.sortDesc[0] == false ? 'ASC'  :'DESC',
              search : this.search
            }
            axios({
          method: "POST",

          url: "/api/get-coupon-codes",
          data: req,
           header : { headers : {
              Authorization:"Bearer " + localStorage.getItem('token')
              },
            }
        })
            .then(response => {

                let data = response.data;

            if (response.data) {
              console.log(data);
                this.coupons = data.data;
                this.pageCountCoupons = data.total_page
                this.totalCountCoupons = data.count
                this.loading = false;
                }else {
                    Vue.$toast.error(data.message, {
                    position: 'top-right'
                    });
                }

            })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },
    getLinks(){
      this.loading = true;
            this.offset = (this.pageLink - 1) * 10
            this.selected_project = name;
            let req = {
              limit : -1,
              offset : this.offset,
              sort : this.datatable_options.sortBy,
              sortDesc : this.datatable_options.sortDesc && this.datatable_options.sortDesc[0] == false ? 'ASC'  :'DESC',
              search : this.search
            }
            axios({
          method: "POST",

          url: "/api/get-custom-links",
          data: req,
           header : { headers : {
              Authorization:"Bearer " + localStorage.getItem('token')
              },
            }
        })
            .then(response => {

                let data = response.data;

            if (response.data) {
                this.links = data.data;
                this.pageCountLink = data.total_page
                this.totalCountLink = data.count
                this.loading = false;
                }else {
                    Vue.$toast.error(data.message, {
                    position: 'top-right'
                    });
                }

            })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },
    getLetters(){
      this.loading = true;
            var offset = (this.page_letter - 1) * 10
            let req = {
              limit : this.limit_letter,
              offset : offset,
              sort : this.datatable_options_letter.sortBy,
              sortDesc : this.datatable_options_letter.sortDesc && this.datatable_options_letter.sortDesc[0] == false ? 'ASC'  :'DESC',
              search : this.search_letter
            }
            axios({
          method: "POST",

          url: "/api/get-all-modules",
          data: req,
           header : { headers : {
              Authorization:"Bearer " + localStorage.getItem('token')
              },
            }
        })
            .then(response => {

                let data = response.data;

            if (response.data) {
                this.letters = data.data;
                this.pageCountLetter = data.total_page
                this.totalCountLetter = data.count
                this.loading = false;
                }else {
                    Vue.$toast.error(data.message, {
                    position: 'top-right'
                    });
                }

            })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },
    closeDeleteBasic () {
        this.dialogDeleteBasic = false
        this.$nextTick(() => {
          this.editedItemBasic = Object.assign({}, {item:''})
          this.editedIndexBasic = -1
        })
      },
    saveSettings: function(e) {
        this.settings.vehicle_packs_description = this.vehicle_packs_description;
        this.settings.vehicle_packs_category = this.vehicle_packs_category;
        this.settings.default_packs = this.settings.default_packs? this.settings.default_packs : [];
        axios({
          method: "POST",

          url: "/api/update-company-settings",
          data: {
            id: this.id,
            settings: this.settings
          }
        })
          .then(response => {
            let data = response.data;
            if (response.data) {
                  Vue.$toast.success('Settings saved', {
                    position: 'top-right'
                  })
            } else {
                Vue.$toast.error(data.message, {
                position: 'top-right'
                });
            }
          })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });
          });
    },
    saveIcon: function(icon) {
      this.icon = icon;
      this.selectedIcon = "mdi-" + icon;
      this.showDialog = false;
    },

    // Reset agent chat prompt to default
    resetAgentChatPrompt() {
      const defaultPrompt = `You are Alex, the AutoSyncX™ Referring Agent Assistant. You're helping someone sign up to become a referring agent during our Beta phase.

🎯 YOUR PERSONALITY:
- Friendly, enthusiastic, and supportive
- Use emojis naturally (but not excessively)
- Keep responses concise and conversational
- Focus on the Beta opportunity and ease of earning
- Be encouraging and make the process feel simple

📋 INFORMATION TO COLLECT:
You need to gather these 6 pieces of information:
1. First Name
2. Last Name
3. Email Address
4. Phone Number
5. Card Color Theme (options: orange, blue, green, purple, red, yellow)
6. Profile Photo Preference (upload their own photo OR use default avatar)

🎯 CONVERSATION RULES:
1. Ask for ONE piece of missing information at a time
2. Be natural and conversational - don't sound robotic
3. When you receive information, acknowledge it warmly before moving to the next field
4. When ALL 6 fields are filled, congratulate them enthusiastically and tell them their account is being created with their referral link

🚀 OPENING MESSAGE:
If this is the first message and you have NO data yet, start with:
"Hey there! 👋 Welcome to AutoSyncX™! I'm Alex, and I'm here to help you become a referring agent. It's super simple - you'll get your own referral link and earn commissions when people use it. Ready to get started? What's your name?"

✅ COMPLETION MESSAGE:
When ALL fields are filled, say something like:
"🎉 Awesome! You're all set! I'm creating your account now with your card theme. You'll get your unique referral link and QR code in just a moment. Welcome to the AutoSyncX™ family! 🚀"

Remember: Be warm, encouraging, and make them feel excited about joining!`;

      this.settings.agent_chat_prompt = defaultPrompt;
      Vue.$toast.success('Reset to default prompt', {
        position: 'top-right'
      });
    },

    // Reset dealer chat prompt to default
    resetDealerChatPrompt() {
      const defaultPrompt = `You are Alex, the official AutoSyncX™️ Dealer Registration Assistant. You help car dealerships join the AutoSyncX™️ network to connect with referral agents nationwide.

YOUR PERSONALITY:
- Professional, friendly, and confident
- Clear and concise communication
- Focus on the value proposition for dealers
- Be encouraging and supportive

INFORMATION TO COLLECT:
1. Dealership Name
2. Contact Person Name
3. Business Email
4. Business Phone
5. Business Address
6. Inventory Count (approximate)
7. Dealer License (optional - can upload later)

CONVERSATION FLOW:
- Start by welcoming them and explaining the benefits
- Collect information one field at a time
- Be natural and conversational
- Acknowledge their responses warmly
- When complete, let them know the team will review and contact them within 24-48 hours

KEY BENEFITS TO MENTION:
- Access to thousands of referral agents nationwide
- Set your own commission structure (flat rate or percentage)
- Easy inventory sync via DMS API or scraping
- Only pay commissions when deals close
- Transparent dashboard for tracking everything

Remember: Be professional, build trust, and make the process feel simple and valuable!`;

      this.settings.dealer_chat_prompt = defaultPrompt;
      Vue.$toast.success('Dealer chat prompt reset to default', {
        position: 'top-right'
      });
    },

    // Reset beamer club chat prompt to default
    resetBeamerClubChatPrompt() {
      const defaultPrompt = `You are Alex with AutoSync Beamer Club. You help members qualify for the BMW Member Program.

YOUR PERSONALITY:
- Warm, professional, and confident
- Use emojis naturally but not excessively
- Keep responses concise and clear
- Focus on the program benefits and ease of qualification

THE PROGRAM:
- Get approved for TWO vehicles in 5-7 days
- One BMW (5, 6, or 7 Series) you drive personally
- Second car goes into income fleet
- Income from second car covers BOTH payment and insurance
- After 6 months: build business credit
- After 12 months: qualify through EIN only (no personal credit needed)
- Can upgrade to luxury tiers (Range Rover, Rolls-Royce)

INFORMATION TO COLLECT:
1. First Name
2. Last Name
3. Email Address
4. Phone Number
5. Date of Birth (MM/DD/YYYY)
6. Last 4 digits of SSN

CONVERSATION FLOW:
1. Greet and explain the program briefly
2. Ask if they want to learn more
3. Explain the two-car system and income coverage
4. Offer to break down the 6-month cycle
5. Collect information for soft credit check (no hard pull)
6. Provide pre-qualification link
7. Offer follow-up support

Remember: Be enthusiastic, make them feel excited about the opportunity, and emphasize that everything is covered!`;

      this.settings.beamer_club_chat_prompt = defaultPrompt;
      Vue.$toast.success('Beamer Club chat prompt reset to default', {
        position: 'top-right'
      });
    },

    // Calculate test payment using current settings
    calculateTestPayment() {
      if (!this.testVehiclePrice || this.testVehiclePrice <= 0) {
        return;
      }

      axios({
        method: "POST",
        url: "/api/calculate-payment",
        data: {
          vehicle_price: this.testVehiclePrice,
          apr_rate: this.settings.loan_apr_rate,
          term_months: this.settings.loan_term_months
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem('token')
        }
      })
      .then(response => {
        if (response.data.flag === 1) {
          this.testPaymentResult = response.data.payment_calculation.monthly_payment;
        } else {
          Vue.$toast.error('Error calculating payment: ' + response.data.message, {
            position: 'top-right'
          });
        }
      })
      .catch(err => {
        Vue.$toast.error('Error calculating payment', {
          position: 'top-right'
        });
      });
    },

    // Retell AI Voice Agent Management Methods
    async loadReferringAgent() {
      try {
        const response = await axios.get('/api/retell/referring-agent/status', {
          headers: {
            'Authorization': "Bearer " + localStorage.getItem('token')
          }
        });
        if (response.data.flag === 1) {
          this.referringAgent = response.data.data;
        } else {
          this.referringAgent = null;
        }
      } catch (error) {
        console.error('Error loading referring agent:', error);
        this.referringAgent = null;
      }
    },

    async createReferringAgent() {
      if (!this.settings.retell_api_key) {
        Vue.$toast.error('Please enter Retell AI API key first', {
          position: 'top-right'
        });
        return;
      }

      if (!this.settings.referring_agent_prompt) {
        Vue.$toast.error('Please enter system prompt for referring agent', {
          position: 'top-right'
        });
        return;
      }

      this.creatingReferringAgent = true;

      try {
        // First save the settings to ensure API key and prompt are stored
        await this.saveSettingsSync();

        // Prepare form data for file upload
        const formData = new FormData();
        formData.append('system_prompt', this.settings.referring_agent_prompt);
        if (this.referringAgentFlowFile) {
          formData.append('flow_file', this.referringAgentFlowFile);
        }

        // Create the referring agent
        const response = await axios.post('/api/retell/referring-agent/create', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': "Bearer " + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.referringAgent = response.data.data;
          Vue.$toast.success('Referring agent ' + (this.referringAgent.has_voice_agent ? 'updated' : 'created') + ' successfully!', {
            position: 'top-right'
          });

          // Reload the agent data
          await this.loadReferringAgent();
        } else {
          Vue.$toast.error('Error: ' + response.data.message, {
            position: 'top-right'
          });
        }
      } catch (error) {
        console.error('Error creating referring agent:', error);
        Vue.$toast.error('Error creating referring agent: ' + (error.response?.data?.message || error.message), {
          position: 'top-right'
        });
      } finally {
        this.creatingReferringAgent = false;
      }
    },

    async loadSalesAgent() {
      try {
        const response = await axios.get('/api/retell/sales-agent/status', {
          headers: {
            'Authorization': "Bearer " + localStorage.getItem('token')
          }
        });
        if (response.data.flag === 1) {
          this.salesAgent = response.data.data;
        } else {
          this.salesAgent = null;
        }
      } catch (error) {
        console.error('Error loading sales agent:', error);
        this.salesAgent = null;
      }
    },

    async createSalesAgent() {
      if (!this.settings.retell_api_key) {
        Vue.$toast.error('Please enter Retell AI API key first', {
          position: 'top-right'
        });
        return;
      }

      if (!this.settings.sales_agent_prompt) {
        Vue.$toast.error('Please enter system prompt for sales agent', {
          position: 'top-right'
        });
        return;
      }

      this.creatingSalesAgent = true;

      try {
        // First save the settings to ensure API key and prompt are stored
        await this.saveSettingsSync();

        // Prepare form data for file upload
        const formData = new FormData();
        formData.append('system_prompt', this.settings.sales_agent_prompt);
        if (this.salesAgentFlowFile) {
          formData.append('flow_file', this.salesAgentFlowFile);
        }

        // Create the sales agent
        const response = await axios.post('/api/retell/sales-agent/create', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': "Bearer " + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.salesAgent = response.data.data;
          Vue.$toast.success('Sales agent ' + (this.salesAgent.has_voice_agent ? 'updated' : 'created') + ' successfully!', {
            position: 'top-right'
          });

          // Reload the agent data
          await this.loadSalesAgent();
        } else {
          Vue.$toast.error('Error: ' + response.data.message, {
            position: 'top-right'
          });
        }
      } catch (error) {
        console.error('Error creating sales agent:', error);
        Vue.$toast.error('Error creating sales agent: ' + (error.response?.data?.message || error.message), {
          position: 'top-right'
        });
      } finally {
        this.creatingSalesAgent = false;
      }
    },

    // Test Referring Agent Voice Call
    async testReferringAgent() {
      if (this.isReferringAgentCallActive) {
        // End the call
        this.endTestCall('referring');
        return;
      }

      if (!this.referringAgent || !this.referringAgent.agent_id) {
        Vue.$toast.error('Referring agent not configured', { position: 'top-right' });
        return;
      }

      this.testingReferringAgent = true;
      this.currentTestAgentType = 'referring';

      try {
        // Import Retell Web SDK dynamically
        if (!this.retellWebClient) {
          try {
            const { RetellWebClient } = await import('retell-client-js-sdk');
            this.retellWebClient = new RetellWebClient();
            this.setupTestCallEventListeners();
          } catch (importError) {
            console.error('Failed to import Retell Web SDK:', importError);
            Vue.$toast.error('Retell Web SDK not available. Please refresh and try again.', { position: 'top-right' });
            return;
          }
        }

        // Call backend to create web call
        const response = await axios.post('/api/retell/create-web-call', {
          agent_id: this.referringAgent.agent_id
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.data.flag === 1) {
          const { access_token } = response.data.data;

          // Start the web call
          await this.retellWebClient.startCall({
            accessToken: access_token,
            sampleRate: 24000,
            captureDeviceId: "default",
            playbackDeviceId: "default",
            emitRawAudioSamples: false
          });

          this.isReferringAgentCallActive = true;
          Vue.$toast.success('Test call started! You can now speak with the Referring Agent.', { position: 'top-right' });
        } else {
          Vue.$toast.error(response.data.message || 'Failed to start test call', { position: 'top-right' });
        }
      } catch (error) {
        console.error('Error starting test call:', error);
        Vue.$toast.error('Error starting test call: ' + (error.response?.data?.message || error.message), { position: 'top-right' });
      } finally {
        this.testingReferringAgent = false;
      }
    },

    // Test Sales Agent Voice Call
    async testSalesAgent() {
      if (this.isSalesAgentCallActive) {
        // End the call
        this.endTestCall('sales');
        return;
      }

      if (!this.salesAgent || !this.salesAgent.agent_id) {
        Vue.$toast.error('Sales agent not configured', { position: 'top-right' });
        return;
      }

      this.testingSalesAgent = true;
      this.currentTestAgentType = 'sales';

      try {
        // Import Retell Web SDK dynamically
        if (!this.retellWebClient) {
          try {
            const { RetellWebClient } = await import('retell-client-js-sdk');
            this.retellWebClient = new RetellWebClient();
            this.setupTestCallEventListeners();
          } catch (importError) {
            console.error('Failed to import Retell Web SDK:', importError);
            Vue.$toast.error('Retell Web SDK not available. Please refresh and try again.', { position: 'top-right' });
            return;
          }
        }

        // Call backend to create web call
        const response = await axios.post('/api/retell/create-web-call', {
          agent_id: this.salesAgent.agent_id
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.data.flag === 1) {
          const { access_token } = response.data.data;

          // Start the web call
          await this.retellWebClient.startCall({
            accessToken: access_token,
            sampleRate: 24000,
            captureDeviceId: "default",
            playbackDeviceId: "default",
            emitRawAudioSamples: false
          });

          this.isSalesAgentCallActive = true;
          Vue.$toast.success('Test call started! You can now speak with the Sales Agent.', { position: 'top-right' });
        } else {
          Vue.$toast.error(response.data.message || 'Failed to start test call', { position: 'top-right' });
        }
      } catch (error) {
        console.error('Error starting test call:', error);
        Vue.$toast.error('Error starting test call: ' + (error.response?.data?.message || error.message), { position: 'top-right' });
      } finally {
        this.testingSalesAgent = false;
      }
    },

    // End test call
    endTestCall(agentType) {
      try {
        if (this.retellWebClient) {
          this.retellWebClient.stopCall();
        }

        if (agentType === 'referring') {
          this.isReferringAgentCallActive = false;
        } else if (agentType === 'sales') {
          this.isSalesAgentCallActive = false;
        }

        Vue.$toast.info('Test call ended', { position: 'top-right' });
      } catch (error) {
        console.error('Error ending test call:', error);
      }
    },

    // Setup event listeners for test calls
    setupTestCallEventListeners() {
      if (!this.retellWebClient) return;

      this.retellWebClient.on("call_started", () => {
        console.log('Test call started');
      });

      this.retellWebClient.on("call_ended", () => {
        console.log('Test call ended');
        this.isReferringAgentCallActive = false;
        this.isSalesAgentCallActive = false;
        this.currentTestAgentType = null;
      });

      this.retellWebClient.on("error", (error) => {
        console.error('Test call error:', error);
        Vue.$toast.error('Call error: ' + (error.message || 'Unknown error'), { position: 'top-right' });
        this.isReferringAgentCallActive = false;
        this.isSalesAgentCallActive = false;
      });

      this.retellWebClient.on("update", (update) => {
        // Handle real-time updates if needed
        console.log('Call update:', update);
      });
    },

    // Synchronous version of saveSettings for use in voice agent creation
    saveSettingsSync() {
      return new Promise((resolve, reject) => {
        this.settings.vehicle_packs_description = this.vehicle_packs_description;
        this.settings.vehicle_packs_category = this.vehicle_packs_category;
        this.settings.default_packs = this.settings.default_packs ? this.settings.default_packs : [];

        axios({
          method: "POST",
          url: "/api/update-company-settings",
          data: {
            id: this.id,
            settings: this.settings
          },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer " + localStorage.getItem('token')
          }
        })
        .then(response => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(new Error(response.data.message || 'Failed to save settings'));
          }
        })
        .catch(err => {
          reject(err);
        });
      });
    },

    // Referral Sweepstakes Methods
    async loadReferralStats() {
      try {
        this.loadingLeaderboard = true;
        const response = await axios({
          method: "GET",
          url: "/api/referral-leaderboard",
          headers: {
            'Authorization': "Bearer " + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.referralStats = {
            total_referrals: response.data.total_referrals || 0,
            top_referrers: response.data.leaderboard || []
          };
        }
      } catch (error) {
        console.error('Error loading referral stats:', error);
      } finally {
        this.loadingLeaderboard = false;
      }
    },

    async openReferredUsersModal(referrer) {
      try {
        this.selectedReferrer = referrer;
        this.referredUsersModal = true;
        this.loadingReferredUsers = true;
        this.referredUsers = [];

        console.log('Loading referred users for:', referrer.user_id);

        const response = await axios({
          method: "GET",
          url: `/api/referred-users/${referrer.user_id}`,
          headers: {
            'Authorization': "Bearer " + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.referredUsers = response.data.referred_users || [];
          console.log('Loaded referred users:', this.referredUsers.length);
        } else {
          this.$toast.error('Failed to load referred users');
        }
      } catch (error) {
        console.error('Error loading referred users:', error);
        this.$toast.error('Error loading referred users');
      } finally {
        this.loadingReferredUsers = false;
      }
    },

    startCountdownTimer() {
      // Update countdown every minute
      this.countdownInterval = setInterval(() => {
        // Force re-render of countdown display
        this.$forceUpdate();
      }, 60000); // Update every minute
    },

    editItem (item) {
        this.editedIndex = this.vehicle_packs_description.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogAddNew = true
      },

      deleteItem (item) {
        this.editedIndex = this.vehicle_packs_description.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.vehicle_packs_description.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialogAddNew = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.vehicle_packs_description[this.editedIndex], this.editedItem)
        } else {
          this.vehicle_packs_description.push(this.editedItem)
        }
        console.log(this.vehicle_packs_description);

        this.close()
      },
      editItemCategory (item) {
        this.editedIndexCategory = this.vehicle_packs_category.indexOf(item)
        this.editedItemCategory = Object.assign({}, item)
        this.dialogAddNewCategory = true
      },

      deleteItemCategory (item) {
        this.editedIndexCategory = this.vehicle_packs_category.indexOf(item)
        this.editedItemCategory = Object.assign({}, item)
        this.dialogDeleteCategory = true
      },

      deleteItemConfirmCategory () {
        this.vehicle_packs_category.splice(this.editedIndexCategory, 1)
        this.closeDeleteCategory()
      },

      closeCategoy () {
        this.dialogAddNewCategory = false
        this.$nextTick(() => {
          this.editedItemCategory = Object.assign({}, this.defaultItem)
          this.editedIndexCategory = -1
        })
      },

      closeDeleteCategory () {
        this.dialogDeleteCategory = false
        this.$nextTick(() => {
          this.editedItemCategory = Object.assign({}, this.defaultItem)
          this.editedIndexCategory = -1
        })
      },

      saveCategory () {
        if (this.editedIndexCategory > -1) {
          Object.assign(this.vehicle_packs_category[this.editedIndexCategory], this.editedItemCategory)
        } else {
          this.vehicle_packs_category.push(this.editedItemCategory)
        }
        console.log(this.vehicle_packs_category);

        this.closeCategoy()
      },

 },

watch: {
  dialogAddNewCategory (val) {
        val || this.closeCategoy()
      },
      dialogDeleteCategory (val) {
        val || this.closeDeleteCategory()
      },
      dialogAddNew (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
  dialogDeleteBasic (val) {
        val || this.closeDeleteBasic()
      },
    searchIcon: function(oldSearchIcon, newSearchIcon) {
    let filteredIcons = [];
    if (this.searchIcon.length === 0) {
      filteredIcons = this.allIcons;
    } else {
      filteredIcons = this.allIcons.filter(i => i.includes(this.searchIcon));
    }
    this.allIcons = filteredIcons;
  },
  datatable_options: {
                handler () {
                    console.log(this.datatable_options);
                this.getProducts()
                },
                deep: true,
            },
  datatable_options_coupons : {
    handler () {
                this.getCoupons()
                },
                deep: true,
  },
  datatable_options_fa : {
    handler () {
                this.getFA()
                },
                deep: true,
  },
  datatable_options_l : {
    handler () {
                this.getL()
                },
                deep: true,
  },
  datatable_options_letter : {
    handler () {
                this.getLetters()
                },
                deep: true,
  },
  page_scrapers: {
    handler() {
      this.getScrapers();
    }
  },
},
created() {
  if(!localStorage.getItem('token')){
    this.$router.push('/login')
    }else{
      console.log('created called.');
      this.getSettings();
      // this.getProducts();
      //this.getLinks()
      this.getAllCompanies();
      this.getLetters();
      this.getPayments();
      this.getScrapers();
      this.loadReferringAgent(); // Load referring agent status
      this.loadSalesAgent(); // Load sales agent status
      this.loadReferralStats(); // Load referral sweepstakes stats
      this.startCountdownTimer(); // Start countdown timer
    }

    },
  beforeDestroy() {
    // Clear countdown timer interval
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },

}
</script>

<style>
.theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
}

.scraper-row {
  cursor: move;
  transition: background-color 0.3s;
}

.scraper-row:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.scraper-row.dragging {
  opacity: 0.5;
  background-color: rgba(0, 0, 0, 0.1);
}

.drag-handle {
  cursor: move;
  margin-right: 8px;
  color: #999;
}
</style>